var _mask, _mask2, _mask3, _mask4, _mask5, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfographics2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 618.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.81,
    y: 162.89,
    width: 16.37,
    height: 16.37,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m346.18,177.9v-13.64c0-.75-.6-1.36-1.36-1.36h-13.64c-.75,0-1.36.61-1.36,1.36v13.64c0,.75.61,1.36,1.36,1.36h13.64c.76,0,1.36-.61,1.36-1.36",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 457.74,
    y: 162.89,
    width: 16.68,
    height: 16.37,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m474.29,177.9v-13.64c0-.75-.61-1.36-1.36-1.36h-13.64c-.75,0-1.36.61-1.36,1.36v13.64c0,.75.61,1.36,1.36,1.36h13.64c.75,0,1.36-.61,1.36-1.36",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 213.6,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -162.55,
    y: -1127.63,
    width: 1309.71,
    height: 3274.29,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_551d7cacd5",
    "data-name": "551d7cacd5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -162.55,
    y: -1127.63,
    width: 1309.71,
    height: 3274.29
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.47,
    y: 213.01,
    width: 867.69,
    height: 3.64,
    style: {
      fill: "#474747"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 213.6,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 298.45,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: -162.55,
    y: -1127.63,
    width: 1309.71,
    height: 3274.29,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_49321ba6bf",
    "data-name": "49321ba6bf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -162.55,
    y: -1127.63,
    width: 1309.71,
    height: 3274.29
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.47,
    y: 296.68,
    width: 867.69,
    height: 3.64,
    style: {
      fill: "#474747"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 298.45,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 383.31,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: -162.55,
    y: -1127.63,
    width: 1309.71,
    height: 3274.29,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_203acceadf",
    "data-name": "203acceadf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -162.55,
    y: -1127.63,
    width: 1309.71,
    height: 3274.29
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.47,
    y: 382.18,
    width: 867.69,
    height: 3.64,
    style: {
      fill: "#474747"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 383.31,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 468.16,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: -162.55,
    y: -1127.63,
    width: 1309.71,
    height: 3274.29,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_444fdf9f61",
    "data-name": "444fdf9f61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -162.55,
    y: -1127.63,
    width: 1309.71,
    height: 3274.29
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.47,
    y: 467.67,
    width: 867.69,
    height: 3.64,
    style: {
      fill: "#474747"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 468.16,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 553.03,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: -162.55,
    y: -1127.63,
    width: 1309.71,
    height: 3274.29,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_75351ef41a",
    "data-name": "75351ef41a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -162.55,
    y: -1127.63,
    width: 1309.71,
    height: 3274.29
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.47,
    y: 551.35,
    width: 867.69,
    height: 3.64,
    style: {
      fill: "#474747"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 553.03,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.61,
    y: 294.86,
    width: 133.7,
    height: 17.64,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m157.26,302.53c0-3.77-3.06-6.82-6.82-6.82s-6.82,3.05-6.82,6.82,3.06,6.82,6.82,6.82,6.82-3.06,6.82-6.82m-6.65-3.07c-1.7-.09-3.14,1.21-3.23,2.9s1.2,3.14,2.89,3.23l123.72,6.79c1.69.09,3.14-1.2,3.23-2.89.09-1.7-1.21-3.14-2.9-3.23l-123.71-6.79",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.74,
    y: 302.14,
    width: 134.61,
    height: 156.44,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m280.97,309.32c0-3.77-3.05-6.82-6.82-6.82s-6.82,3.06-6.82,6.82,3.06,6.82,6.82,6.82,6.82-3.06,6.82-6.82m-4.48-1.98c-1.09-1.29-3.03-1.46-4.33-.36-1.29,1.1-1.45,3.03-.36,4.33l123.71,145.96c1.09,1.29,3.03,1.45,4.33.36s1.45-3.03.36-4.33l-123.71-145.95",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.55,
    y: 447.66,
    width: 134.5,
    height: 49.02,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m404.68,455.27c0-3.77-3.06-6.82-6.82-6.82s-6.82,3.05-6.82,6.82,3.05,6.82,6.82,6.82,6.82-3.06,6.82-6.82m-5.94-2.94c-1.62-.49-3.33.43-3.82,2.05-.49,1.62.43,3.33,2.05,3.82l123.71,37.34c1.63.49,3.34-.43,3.83-2.05s-.43-3.33-2.05-3.82l-123.72-37.34",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 514.7,
    y: 485.77,
    width: 134.04,
    height: 20.1,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528.39,492.61c0-3.77-3.06-6.82-6.82-6.82s-6.82,3.06-6.82,6.82,3.06,6.82,6.82,6.82,6.82-3.06,6.82-6.82m-6.57-3.06c-1.68-.14-3.17,1.12-3.31,2.81-.14,1.69,1.12,3.17,2.81,3.31l123.71,10.18c1.69.14,3.17-1.12,3.31-2.81.14-1.69-1.12-3.18-2.81-3.31l-123.72-10.18",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 637.83,
    y: 495.32,
    width: 134.61,
    height: 61.49,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m652.1,502.79c0-3.77-3.05-6.82-6.82-6.82s-6.82,3.06-6.82,6.82,3.06,6.82,6.82,6.82,6.82-3.06,6.82-6.82m-5.65-2.84c-1.57-.65-3.36.1-4.01,1.67-.65,1.56.1,3.36,1.67,4.01l123.71,50.91c1.57.65,3.36-.1,4.01-1.67s-.1-3.36-1.67-4.01l-123.71-50.91",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 761.64,
    y: 433.93,
    width: 138.13,
    height: 126.88,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m775.82,553.71c0-3.77-3.06-6.82-6.82-6.82s-6.82,3.05-6.82,6.82,3.05,6.82,6.82,6.82,6.82-3.06,6.82-6.82m-8.88-2.28c-1.26,1.14-1.36,3.08-.22,4.34,1.14,1.25,3.08,1.35,4.34.21l123.71-112.01c1.26-1.14,1.35-3.08.21-4.33s-3.08-1.36-4.33-.21l-123.71,112.01m132.59-109.73c0-3.77-3.06-6.82-6.82-6.82s-6.82,3.06-6.82,6.82,3.06,6.82,6.82,6.82,6.82-3.06,6.82-6.82",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.61,
    y: 545.89,
    width: 133.7,
    height: 14.91,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m157.26,553.71c0-3.77-3.06-6.82-6.82-6.82s-6.82,3.05-6.82,6.82,3.06,6.82,6.82,6.82,6.82-3.06,6.82-6.82m-6.82-3.07c-1.7,0-3.07,1.37-3.07,3.07s1.37,3.07,3.07,3.07h123.71c1.7,0,3.07-1.38,3.07-3.07s-1.37-3.07-3.07-3.07h-123.71",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.74,
    y: 211.19,
    width: 134.61,
    height: 349.62,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m280.97,553.71c0-3.77-3.05-6.82-6.82-6.82s-6.82,3.05-6.82,6.82,3.06,6.82,6.82,6.82,6.82-3.06,6.82-6.82m-9.71-1.05c-.58,1.59.24,3.35,1.83,3.93,1.6.58,3.36-.23,3.94-1.83l123.72-339.44c.58-1.59-.24-3.35-1.83-3.93-1.6-.58-3.36.23-3.94,1.83l-123.72,339.43",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.55,
    y: 207.46,
    width: 134.5,
    height: 13.64,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m404.68,214.28c0-3.77-3.06-6.82-6.82-6.82s-6.82,3.05-6.82,6.82,3.05,6.82,6.82,6.82,6.82-3.06,6.82-6.82m-6.82-3.07c-1.7,0-3.07,1.37-3.07,3.07s1.37,3.07,3.07,3.07h123.71c1.7,0,3.07-1.38,3.07-3.07s-1.37-3.07-3.07-3.07h-123.71",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 514.7,
    y: 207.46,
    width: 134.04,
    height: 170.54,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528.39,214.28c0-3.77-3.06-6.82-6.82-6.82s-6.82,3.05-6.82,6.82,3.06,6.82,6.82,6.82,6.82-3.06,6.82-6.82m-4.4-1.88c-1.04-1.34-2.96-1.58-4.31-.55-1.34,1.04-1.58,2.97-.54,4.31l123.71,159.54c1.04,1.34,2.97,1.58,4.31.54,1.34-1.04,1.58-2.96.55-4.31l-123.72-159.53",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 637.83,
    y: 302.14,
    width: 134.61,
    height: 78.58,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m652.1,373.81c0-3.77-3.05-6.82-6.82-6.82s-6.82,3.06-6.82,6.82,3.06,6.82,6.82,6.82,6.82-3.06,6.82-6.82m-8.29-2.69c-1.49.82-2.03,2.69-1.22,4.17.81,1.49,2.68,2.03,4.16,1.22l123.71-67.89c1.49-.82,2.03-2.68,1.22-4.17-.81-1.49-2.68-2.03-4.16-1.22l-123.71,67.89",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 761.64,
    y: 207.46,
    width: 138.13,
    height: 105.6,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m775.82,305.92c0-3.77-3.06-6.82-6.82-6.82s-6.82,3.06-6.82,6.82,3.05,6.82,6.82,6.82,6.82-3.06,6.82-6.82m-8.65-2.47c-1.36,1.01-1.65,2.93-.64,4.29,1.01,1.36,2.93,1.65,4.29.64l123.71-91.64c1.36-1.01,1.65-2.93.64-4.3-1.01-1.36-2.93-1.65-4.29-.64l-123.71,91.65m132.36-89.18c0-3.77-3.06-6.82-6.82-6.82s-6.82,3.05-6.82,6.82,3.06,6.82,6.82,6.82,6.82-3.06,6.82-6.82",
    style: {
      fill: "none"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 618.83
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m364.15,176.53v-12.96h2.19v12.96h-2.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.46,167.01c1.17,0,2.08.28,2.73.82.66.53,1,1.31,1.02,2.33h-2.02c0-.55-.16-.95-.45-1.22-.31-.28-.74-.43-1.31-.43-.5,0-.87.11-1.14.31-.27.19-.4.45-.4.8,0,.25.06.45.2.6.15.16.36.28.63.37.26.1.69.22,1.28.37.8.19,1.41.38,1.85.57.45.17.84.45,1.17.85.32.4.48.93.48,1.59,0,.85-.36,1.55-1.05,2.07-.7.51-1.65.77-2.84.77s-2.23-.28-2.93-.85c-.7-.57-1.05-1.39-1.05-2.47h2.1c0,.57.16,1.01.48,1.31.34.31.82.45,1.45.45.51,0,.92-.1,1.22-.31.3-.21.45-.48.45-.82,0-.3-.09-.54-.26-.71-.16-.18-.38-.33-.68-.43-.28-.11-.75-.24-1.39-.4-.72-.17-1.29-.33-1.71-.48-.4-.17-.75-.43-1.05-.8-.28-.38-.43-.88-.43-1.51,0-.55.15-1.03.45-1.45.3-.41.72-.74,1.28-.97.55-.24,1.18-.37,1.9-.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.14,167.15c.23,0,.48.04.77.11v1.82c-.25-.04-.5-.06-.74-.06-.84,0-1.47.26-1.9.77-.44.51-.65,1.25-.65,2.22v4.52h-2.07v-9.24h1.93v1.36h.03c.6-1,1.49-1.51,2.64-1.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.83,167.01c1.25,0,2.2.31,2.84.91.64.61.97,1.52.97,2.73v3.44c0,1.01.07,1.82.23,2.44h-1.88c-.08-.38-.11-.8-.11-1.28h-.03c-.68.99-1.73,1.48-3.13,1.48-.95,0-1.71-.26-2.27-.77s-.85-1.17-.85-1.99c0-.77.26-1.4.8-1.88.55-.47,1.46-.81,2.76-1.02.77-.13,1.61-.23,2.5-.28v-.34c0-.66-.16-1.14-.48-1.45-.33-.32-.77-.48-1.34-.48s-.99.16-1.31.45c-.31.28-.48.68-.51,1.17h-2.02c.04-.91.38-1.66,1.05-2.25.66-.58,1.59-.88,2.79-.88Zm1.82,5.14c-.8.04-1.51.11-2.13.23-.67.11-1.14.28-1.42.51-.27.21-.4.53-.4.94s.14.75.43.99c.28.25.68.37,1.19.37.34,0,.65-.04.94-.14.28-.11.53-.26.74-.45.24-.26.41-.54.51-.82.09-.28.14-.67.14-1.17v-.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.02,175.28c.57,0,1.04-.14,1.42-.43.38-.28.61-.65.71-1.11h2.13c-.19.87-.67,1.61-1.42,2.19-.74.59-1.69.88-2.84.88-.93,0-1.73-.21-2.42-.63-.67-.43-1.18-1.02-1.53-1.76-.36-.75-.54-1.63-.54-2.61,0-.91.17-1.72.51-2.44.36-.74.87-1.31,1.53-1.73.68-.41,1.48-.63,2.39-.63,1.06,0,1.95.28,2.67.85.74.57,1.23,1.34,1.48,2.3.17.55.26,1.27.26,2.16h-6.76c.04,1.01.27,1.76.71,2.25.43.48,1,.71,1.71.71Zm-.06-6.74c-.63,0-1.16.21-1.59.63-.42.42-.67,1.02-.74,1.79h4.66c-.06-.77-.31-1.37-.74-1.79-.42-.41-.95-.63-1.59-.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.41,176.53v-12.96h2.07v12.96h-2.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.94,163.57c1.49,0,2.64.37,3.44,1.11.8.72,1.19,1.7,1.19,2.93s-.4,2.25-1.19,2.98c-.8.72-1.95,1.08-3.44,1.08h-2.5v4.86h-2.19v-12.96h4.69Zm-2.5,6.25h2.25c.89,0,1.55-.18,1.99-.57.43-.38.65-.92.65-1.65s-.22-1.24-.65-1.62c-.44-.38-1.1-.57-1.99-.57h-2.25v4.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.82,167.01c1.25,0,2.2.31,2.84.91.64.61.97,1.52.97,2.73v3.44c0,1.01.07,1.82.23,2.44h-1.88c-.08-.38-.11-.8-.11-1.28h-.03c-.68.99-1.73,1.48-3.13,1.48-.95,0-1.71-.26-2.27-.77s-.85-1.17-.85-1.99c0-.77.26-1.4.8-1.88.55-.47,1.46-.81,2.76-1.02.77-.13,1.61-.23,2.5-.28v-.34c0-.66-.16-1.14-.48-1.45-.33-.32-.77-.48-1.34-.48s-.99.16-1.31.45c-.31.28-.48.68-.51,1.17h-2.02c.04-.91.38-1.66,1.05-2.25.66-.58,1.59-.88,2.79-.88Zm1.82,5.14c-.8.04-1.51.11-2.13.23-.67.11-1.14.28-1.42.51-.27.21-.4.53-.4.94s.14.75.43.99c.28.25.68.37,1.19.37.34,0,.65-.04.94-.14.28-.11.53-.26.74-.45.24-.26.41-.54.51-.82.09-.28.14-.67.14-1.17v-.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m513.18,176.53v-12.96h2.07v12.96h-2.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m521.75,175.28c.57,0,1.04-.14,1.42-.43.38-.28.61-.65.71-1.11h2.13c-.19.87-.67,1.61-1.42,2.19-.74.59-1.69.88-2.84.88-.93,0-1.73-.21-2.42-.63-.67-.43-1.18-1.02-1.53-1.76-.36-.75-.54-1.63-.54-2.61,0-.91.17-1.72.51-2.44.36-.74.87-1.31,1.53-1.73.68-.41,1.48-.63,2.39-.63,1.06,0,1.95.28,2.67.85.74.57,1.23,1.34,1.48,2.3.17.55.26,1.27.26,2.16h-6.76c.04,1.01.27,1.76.71,2.25.43.48,1,.71,1.71.71Zm-.06-6.74c-.63,0-1.16.21-1.59.63-.42.42-.67,1.02-.74,1.79h4.66c-.06-.77-.31-1.37-.74-1.79-.42-.41-.95-.63-1.59-.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m531.31,167.01c1.17,0,2.08.28,2.73.82.66.53,1,1.31,1.02,2.33h-2.02c0-.55-.16-.95-.45-1.22-.31-.28-.74-.43-1.31-.43-.5,0-.87.11-1.14.31-.27.19-.4.45-.4.8,0,.25.06.45.2.6.15.16.36.28.63.37.26.1.69.22,1.28.37.8.19,1.41.38,1.85.57.45.17.84.45,1.17.85.32.4.48.93.48,1.59,0,.85-.36,1.55-1.05,2.07-.7.51-1.65.77-2.84.77s-2.23-.28-2.93-.85c-.7-.57-1.05-1.39-1.05-2.47h2.1c0,.57.16,1.01.48,1.31.34.31.82.45,1.45.45.51,0,.92-.1,1.22-.31.3-.21.45-.48.45-.82,0-.3-.09-.54-.26-.71-.16-.18-.38-.33-.68-.43-.28-.11-.75-.24-1.39-.4-.72-.17-1.29-.33-1.71-.48-.4-.17-.75-.43-1.05-.8-.28-.38-.43-.88-.43-1.51,0-.55.15-1.03.45-1.45.3-.41.72-.74,1.28-.97.55-.24,1.18-.37,1.9-.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m541.08,174.94c.26,0,.48-.03.65-.09v1.62c-.38.11-.77.17-1.17.17-.99,0-1.71-.21-2.16-.65-.44-.45-.65-1.18-.65-2.19v-4.92h-1.53v-1.59h1.53v-2.3h2.07v2.3h1.79v1.59h-1.79v4.6c0,.53.09.91.28,1.14.21.21.53.31.97.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m543.55,176.53v-9.24h2.07v9.24h-2.07Zm0-10.97v-1.99h2.07v1.99h-2.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m553.02,167.06c1.08,0,1.91.33,2.5.97.58.65.88,1.59.88,2.84v5.66h-2.07v-5.49c0-1.53-.63-2.3-1.88-2.3-.63,0-1.14.24-1.53.71-.38.45-.57,1.11-.57,1.96v5.12h-2.07v-9.24h1.96v1.19h.03c.3-.43.69-.77,1.17-1.02.47-.26,1-.4,1.59-.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m558.97,176.53v-9.24h2.07v9.24h-2.07Zm0-10.97v-1.99h2.07v1.99h-2.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567.13,167.01c1.25,0,2.2.31,2.84.91.64.61.97,1.52.97,2.73v3.44c0,1.01.07,1.82.23,2.44h-1.88c-.08-.38-.11-.8-.11-1.28h-.03c-.68.99-1.73,1.48-3.13,1.48-.95,0-1.71-.26-2.27-.77s-.85-1.17-.85-1.99c0-.77.26-1.4.8-1.88.55-.47,1.46-.81,2.76-1.02.77-.13,1.61-.23,2.5-.28v-.34c0-.66-.16-1.14-.48-1.45-.33-.32-.77-.48-1.34-.48s-.99.16-1.31.45c-.31.28-.48.68-.51,1.17h-2.02c.04-.91.38-1.66,1.05-2.25.66-.58,1.59-.88,2.79-.88Zm1.82,5.14c-.8.04-1.51.11-2.13.23-.67.11-1.14.28-1.42.51-.27.21-.4.53-.4.94s.14.75.43.99c.28.25.68.37,1.19.37.34,0,.65-.04.94-.14.28-.11.53-.26.74-.45.24-.26.41-.54.51-.82.09-.28.14-.67.14-1.17v-.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m578.24,167.06c1.08,0,1.91.33,2.5.97.58.65.88,1.59.88,2.84v5.66h-2.07v-5.49c0-1.53-.63-2.3-1.88-2.3-.63,0-1.14.24-1.53.71-.38.45-.57,1.11-.57,1.96v5.12h-2.07v-9.24h1.96v1.19h.03c.3-.43.69-.77,1.17-1.02.47-.26,1-.4,1.59-.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m590.59,173.01l-1.19,3.52h-2.27l4.69-12.96h2.93l4.72,12.96h-2.3l-1.19-3.52h-5.37Zm4.38-2.9c-.72-2.16-1.28-3.87-1.68-5.14h-.03c-.65,2.1-1.19,3.82-1.65,5.14l-.37,1.02h4.06l-.34-1.02Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m604.13,176.76c-1.07,0-1.89-.32-2.47-.97-.59-.64-.88-1.59-.88-2.84v-5.66h2.05v5.49c0,1.53.63,2.3,1.88,2.3.63,0,1.14-.23,1.53-.68.4-.47.6-1.14.6-1.99v-5.12h2.07v9.24h-1.99v-1.19h-.03c-.31.44-.7.79-1.17,1.05-.48.24-1.01.37-1.59.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m615.25,174.94c.26,0,.48-.03.65-.09v1.62c-.38.11-.77.17-1.17.17-.99,0-1.71-.21-2.16-.65-.44-.45-.65-1.18-.65-2.19v-4.92h-1.53v-1.59h1.53v-2.3h2.07v2.3h1.79v1.59h-1.79v4.6c0,.53.09.91.28,1.14.21.21.53.31.97.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m619.82,168.37c.32-.43.71-.75,1.17-.97.45-.23.95-.34,1.48-.34,1.08,0,1.91.33,2.5.97.58.65.88,1.59.88,2.84v5.66h-2.07v-5.49c0-1.53-.63-2.3-1.88-2.3-.63,0-1.14.24-1.53.71-.38.45-.57,1.11-.57,1.96v5.12h-2.07v-12.96h2.07v4.8h.03Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m632.33,167.01c.92,0,1.73.21,2.42.63.68.4,1.2.97,1.56,1.71.38.72.57,1.58.57,2.56s-.19,1.88-.57,2.61c-.36.72-.88,1.29-1.56,1.71-.68.4-1.49.6-2.42.6s-1.75-.2-2.44-.6c-.68-.41-1.22-.98-1.59-1.71-.36-.74-.54-1.61-.54-2.61s.18-1.83.54-2.56c.38-.74.91-1.31,1.59-1.71.7-.41,1.51-.63,2.44-.63Zm0,1.65c-.74,0-1.33.3-1.76.88-.42.57-.63,1.36-.63,2.36s.21,1.83.63,2.42c.43.57,1.02.85,1.76.85s1.31-.28,1.73-.85c.43-.58.65-1.39.65-2.42s-.22-1.79-.65-2.36c-.42-.58-.99-.88-1.73-.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m643.51,167.15c.23,0,.48.04.77.11v1.82c-.25-.04-.5-.06-.74-.06-.84,0-1.47.26-1.9.77-.44.51-.65,1.25-.65,2.22v4.52h-2.07v-9.24h1.93v1.36h.03c.6-1,1.49-1.51,2.64-1.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m645.76,176.53v-9.24h2.07v9.24h-2.07Zm0-10.97v-1.99h2.07v1.99h-2.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m654.18,174.94c.26,0,.48-.03.65-.09v1.62c-.38.11-.77.17-1.17.17-.99,0-1.71-.21-2.16-.65-.44-.45-.65-1.18-.65-2.19v-4.92h-1.53v-1.59h1.53v-2.3h2.07v2.3h1.79v1.59h-1.79v4.6c0,.53.09.91.28,1.14.21.21.53.31.97.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660.74,176.93c-.31.8-.64,1.41-.99,1.85-.34.43-.76.75-1.25.94-.48.18-1.07.28-1.79.28-.38,0-.73-.05-1.05-.14v-1.68c.28.07.58.11.88.11.55,0,.97-.13,1.28-.37.3-.25.55-.68.77-1.31l-3.38-9.32h2.22l2.33,6.88h.03l2.39-6.88h2.13l-3.55,9.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-1)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m329.81,162.89h144.61v16.37h-144.61v-16.37Z",
    style: {
      fill: "#ff5722"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-2)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-3)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m329.81,162.89h144.61v16.37h-144.61v-16.37Z",
    style: {
      fill: "#9d22ff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m120.58,578.72v-8.61h-2.84v-1.56c.98,0,1.71-.16,2.19-.48.49-.32.8-.85.91-1.59h1.9v12.25h-2.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.12,579c-1.14,0-2.06-.31-2.76-.94-.7-.63-1.09-1.49-1.17-2.61h2.19c.07.59.27,1.02.6,1.31.32.28.74.43,1.25.43.8,0,1.43-.34,1.9-1.02.49-.68.75-1.72.8-3.13h-.06c-.74.95-1.71,1.42-2.9,1.42-.78,0-1.47-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.57.54-2.22.38-.64.9-1.14,1.56-1.51.68-.36,1.45-.54,2.3-.54,1.46,0,2.57.5,3.35,1.51.77,1.01,1.17,2.5,1.17,4.49,0,2.18-.43,3.87-1.28,5.06-.84,1.18-2.02,1.76-3.55,1.76Zm.28-6.22c.64,0,1.17-.23,1.56-.68s.6-1.03.6-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.59.65c-.38.44-.57,1.02-.57,1.76s.18,1.3.57,1.73c.38.44.9.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.52,568.23l-.34,3.33h.03c.3-.3.66-.53,1.08-.68.43-.17.89-.26,1.36-.26.8,0,1.49.17,2.1.51.63.33,1.09.8,1.42,1.42.34.61.51,1.31.51,2.1,0,.87-.19,1.64-.57,2.3-.36.65-.88,1.15-1.56,1.51-.68.36-1.48.54-2.39.54-1.27,0-2.29-.32-3.04-.97-.76-.64-1.14-1.51-1.14-2.61h2.16c.01.55.21.99.6,1.31.38.31.85.45,1.42.45.72,0,1.28-.21,1.68-.63.4-.43.6-1.04.6-1.82s-.2-1.34-.6-1.76c-.38-.41-.91-.63-1.59-.63-.53,0-.98.14-1.34.4-.34.27-.58.64-.71,1.11l-2.13-.14.71-7.25h7.3v1.76h-5.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.24,579c-1.14,0-2.06-.31-2.76-.94-.7-.63-1.09-1.49-1.17-2.61h2.19c.07.59.27,1.02.6,1.31.32.28.74.43,1.25.43.8,0,1.43-.34,1.9-1.02.49-.68.75-1.72.8-3.13h-.06c-.74.95-1.71,1.42-2.9,1.42-.78,0-1.47-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.57.54-2.22.38-.64.9-1.14,1.56-1.51.68-.36,1.45-.54,2.3-.54,1.46,0,2.57.5,3.35,1.51.77,1.01,1.17,2.5,1.17,4.49,0,2.18-.43,3.87-1.28,5.06-.84,1.18-2.02,1.76-3.55,1.76Zm.28-6.22c.64,0,1.17-.23,1.56-.68s.6-1.03.6-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.59.65c-.38.44-.57,1.02-.57,1.76s.18,1.3.57,1.73c.38.44.9.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.72,574.25v-1.71h4.55v1.71h-4.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.45,579c-1.14,0-2.06-.31-2.76-.94-.7-.63-1.09-1.49-1.17-2.61h2.19c.07.59.27,1.02.6,1.31.32.28.74.43,1.25.43.8,0,1.43-.34,1.9-1.02.49-.68.75-1.72.8-3.13h-.06c-.74.95-1.71,1.42-2.9,1.42-.78,0-1.47-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.57.54-2.22.38-.64.9-1.14,1.56-1.51.68-.36,1.45-.54,2.3-.54,1.46,0,2.57.5,3.35,1.51.77,1.01,1.17,2.5,1.17,4.49,0,2.18-.43,3.87-1.28,5.06-.84,1.18-2.02,1.76-3.55,1.76Zm.28-6.22c.64,0,1.17-.23,1.56-.68s.6-1.03.6-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.59.65c-.38.44-.57,1.02-.57,1.76s.18,1.3.57,1.73c.38.44.9.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.64,566.18c1.29,0,2.3.31,3.04.94.75.61,1.14,1.44,1.14,2.47,0,.7-.17,1.28-.51,1.73-.34.44-.88.79-1.62,1.05v.06c.81.27,1.4.65,1.76,1.14.38.48.57,1.1.57,1.88,0,.72-.18,1.35-.54,1.88-.36.53-.87.95-1.53,1.25-.67.28-1.42.43-2.27.43-1.44,0-2.55-.36-3.33-1.08-.78-.72-1.17-1.74-1.17-3.07h2.16c0,.78.18,1.36.57,1.76.4.38.98.57,1.76.57.64,0,1.17-.16,1.56-.48.4-.34.6-.78.6-1.34,0-1.29-.9-1.93-2.67-1.93h-.45v-1.76h.45c.77,0,1.39-.17,1.85-.51s.68-.8.68-1.36c0-.53-.2-.97-.6-1.31-.38-.34-.9-.51-1.53-.51s-1.19.19-1.56.57c-.36.36-.54.91-.54,1.65h-2.16c0-1.25.38-2.22,1.14-2.93.77-.72,1.85-1.08,3.21-1.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.29,578.72v-8.61h-2.84v-1.56c.98,0,1.71-.16,2.19-.48.49-.32.8-.85.91-1.59h1.9v12.25h-2.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.83,579c-1.14,0-2.06-.31-2.76-.94-.7-.63-1.09-1.49-1.17-2.61h2.19c.07.59.27,1.02.6,1.31.32.28.74.43,1.25.43.8,0,1.43-.34,1.9-1.02.49-.68.75-1.72.8-3.13h-.06c-.74.95-1.71,1.42-2.9,1.42-.78,0-1.47-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.57.54-2.22.38-.64.9-1.14,1.56-1.51.68-.36,1.45-.54,2.3-.54,1.46,0,2.57.5,3.35,1.51.77,1.01,1.17,2.5,1.17,4.49,0,2.18-.43,3.87-1.28,5.06-.84,1.18-2.02,1.76-3.55,1.76Zm.28-6.22c.64,0,1.17-.23,1.56-.68s.6-1.03.6-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.59.65c-.38.44-.57,1.02-.57,1.76s.18,1.3.57,1.73c.38.44.9.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.39,579c-1.14,0-2.06-.31-2.76-.94-.7-.63-1.09-1.49-1.17-2.61h2.19c.07.59.27,1.02.6,1.31.32.28.74.43,1.25.43.8,0,1.43-.34,1.9-1.02.49-.68.75-1.72.8-3.13h-.06c-.74.95-1.71,1.42-2.9,1.42-.78,0-1.47-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.57.54-2.22.38-.64.9-1.14,1.56-1.51.68-.36,1.45-.54,2.3-.54,1.46,0,2.57.5,3.35,1.51.77,1.01,1.17,2.5,1.17,4.49,0,2.18-.43,3.87-1.28,5.06-.84,1.18-2.02,1.76-3.55,1.76Zm.28-6.22c.64,0,1.17-.23,1.56-.68s.6-1.03.6-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.59.65c-.38.44-.57,1.02-.57,1.76s.18,1.3.57,1.73c.38.44.9.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.62,575.76v2.96h-2.16v-2.96h-5.83v-1.85l5.12-7.45h2.87v7.59h1.88v1.71h-1.88Zm-2.1-1.71v-1.59c0-1.26.03-2.71.09-4.32h-.03c-.59.97-1.47,2.32-2.64,4.04l-1.28,1.88h3.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.43,574.25v-1.71h4.55v1.71h-4.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.19,578.72v-8.61h-2.84v-1.56c.98,0,1.71-.16,2.19-.48.49-.32.8-.85.91-1.59h1.9v12.25h-2.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.38,566.18c.81,0,1.54.14,2.19.43.64.27,1.14.65,1.51,1.17.36.51.54,1.1.54,1.76s-.2,1.27-.6,1.76c-.38.48-.91.82-1.59,1.02v.06c.75.21,1.35.58,1.79,1.11.43.53.65,1.18.65,1.93s-.19,1.36-.57,1.9c-.36.53-.88.95-1.56,1.25-.68.28-1.47.43-2.36.43s-1.68-.14-2.36-.43c-.67-.3-1.19-.72-1.56-1.25-.38-.55-.57-1.18-.57-1.9s.21-1.4.65-1.93c.43-.53,1.03-.9,1.79-1.11v-.06c-.68-.21-1.22-.55-1.62-1.02-.38-.49-.57-1.08-.57-1.76s.18-1.25.54-1.76c.38-.51.88-.9,1.51-1.17.64-.28,1.37-.43,2.19-.43Zm0,1.79c-.65,0-1.17.16-1.56.48-.38.31-.57.72-.57,1.25,0,.57.18,1.02.57,1.34.38.33.9.48,1.56.48s1.18-.16,1.56-.48c.38-.32.57-.77.57-1.34,0-.53-.2-.95-.6-1.25-.38-.32-.9-.48-1.53-.48Zm0,5.32c-.68,0-1.24.18-1.68.54-.42.34-.63.81-.63,1.39s.2,1.07.6,1.42c.41.36.98.54,1.71.54s1.26-.18,1.68-.54c.43-.36.65-.83.65-1.42s-.22-1.03-.65-1.39c-.42-.36-.98-.54-1.68-.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.44,578.72v-8.61h-2.84v-1.56c.98,0,1.71-.16,2.19-.48.49-.32.8-.85.91-1.59h1.9v12.25h-2.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.97,579c-1.14,0-2.06-.31-2.76-.94-.7-.63-1.09-1.49-1.17-2.61h2.19c.07.59.27,1.02.6,1.31.32.28.74.43,1.25.43.8,0,1.43-.34,1.9-1.02.49-.68.75-1.72.8-3.13h-.06c-.74.95-1.71,1.42-2.9,1.42-.78,0-1.47-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.57.54-2.22.38-.64.9-1.14,1.56-1.51.68-.36,1.45-.54,2.3-.54,1.46,0,2.57.5,3.35,1.51.77,1.01,1.17,2.5,1.17,4.49,0,2.18-.43,3.87-1.28,5.06-.84,1.18-2.02,1.76-3.55,1.76Zm.28-6.22c.64,0,1.17-.23,1.56-.68s.6-1.03.6-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.59.65c-.38.44-.57,1.02-.57,1.76s.18,1.3.57,1.73c.38.44.9.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.54,579c-1.14,0-2.06-.31-2.76-.94-.7-.63-1.09-1.49-1.17-2.61h2.19c.07.59.27,1.02.6,1.31.32.28.74.43,1.25.43.8,0,1.43-.34,1.9-1.02.49-.68.75-1.72.8-3.13h-.06c-.74.95-1.71,1.42-2.9,1.42-.78,0-1.47-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.57.54-2.22.38-.64.9-1.14,1.56-1.51.68-.36,1.45-.54,2.3-.54,1.46,0,2.57.5,3.35,1.51.77,1.01,1.17,2.5,1.17,4.49,0,2.18-.43,3.87-1.28,5.06-.84,1.18-2.02,1.76-3.55,1.76Zm.28-6.22c.64,0,1.17-.23,1.56-.68s.6-1.03.6-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.59.65c-.38.44-.57,1.02-.57,1.76s.18,1.3.57,1.73c.38.44.9.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.1,579c-1.14,0-2.06-.31-2.76-.94-.7-.63-1.09-1.49-1.17-2.61h2.19c.07.59.27,1.02.6,1.31.32.28.74.43,1.25.43.8,0,1.43-.34,1.9-1.02.49-.68.75-1.72.8-3.13h-.06c-.74.95-1.71,1.42-2.9,1.42-.78,0-1.47-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.57.54-2.22.38-.64.9-1.14,1.56-1.51.68-.36,1.45-.54,2.3-.54,1.46,0,2.57.5,3.35,1.51.77,1.01,1.17,2.5,1.17,4.49,0,2.18-.43,3.87-1.28,5.06-.84,1.18-2.02,1.76-3.55,1.76Zm.28-6.22c.64,0,1.17-.23,1.56-.68s.6-1.03.6-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.59.65c-.38.44-.57,1.02-.57,1.76s.18,1.3.57,1.73c.38.44.9.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.57,574.25v-1.71h4.55v1.71h-4.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.96,566.18c.81,0,1.52.14,2.13.43.63.28,1.11.7,1.45,1.22.34.51.51,1.12.51,1.82s-.14,1.28-.4,1.79c-.25.5-.6.93-1.05,1.31-.45.36-1.05.75-1.79,1.17-.78.45-1.36.85-1.76,1.17-.4.33-.68.63-.82.91-.16.28-.24.6-.26.94h6.37v1.79h-8.84v-.37c0-.85.09-1.57.28-2.16.18-.58.54-1.14,1.05-1.68.51-.55,1.25-1.09,2.22-1.65.7-.4,1.23-.74,1.59-1.02.38-.28.67-.58.88-.91.21-.34.31-.74.31-1.19,0-.53-.17-.95-.51-1.25-.34-.32-.8-.48-1.36-.48-1.36,0-2.07.72-2.13,2.16h-2.16c.01-1.26.41-2.25,1.17-2.93.75-.7,1.8-1.05,3.13-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.52,566.18c1.51,0,2.67.56,3.47,1.68.8,1.1,1.19,2.67,1.19,4.72s-.4,3.66-1.19,4.78c-.8,1.1-1.95,1.65-3.47,1.65s-2.66-.55-3.47-1.65c-.8-1.12-1.19-2.71-1.19-4.78s.4-3.62,1.19-4.72c.81-1.12,1.97-1.68,3.47-1.68Zm0,1.85c-.78,0-1.39.39-1.82,1.17-.42.78-.63,1.9-.63,3.38s.21,2.61.63,3.41c.43.8,1.04,1.19,1.82,1.19s1.37-.4,1.79-1.19c.41-.8.63-1.93.63-3.41s-.21-2.6-.63-3.38c-.42-.77-1.02-1.17-1.79-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.08,566.18c1.51,0,2.67.56,3.47,1.68.8,1.1,1.19,2.67,1.19,4.72s-.4,3.66-1.19,4.78c-.8,1.1-1.95,1.65-3.47,1.65s-2.66-.55-3.47-1.65c-.8-1.12-1.19-2.71-1.19-4.78s.4-3.62,1.19-4.72c.81-1.12,1.97-1.68,3.47-1.68Zm0,1.85c-.78,0-1.39.39-1.82,1.17-.42.78-.63,1.9-.63,3.38s.21,2.61.63,3.41c.43.8,1.04,1.19,1.82,1.19s1.37-.4,1.79-1.19c.41-.8.63-1.93.63-3.41s-.21-2.6-.63-3.38c-.42-.77-1.02-1.17-1.79-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.62,566.18c1.29,0,2.3.31,3.04.94.75.61,1.14,1.44,1.14,2.47,0,.7-.17,1.28-.51,1.73-.34.44-.88.79-1.62,1.05v.06c.81.27,1.4.65,1.76,1.14.38.48.57,1.1.57,1.88,0,.72-.18,1.35-.54,1.88-.36.53-.87.95-1.53,1.25-.67.28-1.42.43-2.27.43-1.44,0-2.55-.36-3.33-1.08-.78-.72-1.17-1.74-1.17-3.07h2.16c0,.78.18,1.36.57,1.76.4.38.98.57,1.76.57.64,0,1.17-.16,1.56-.48.4-.34.6-.78.6-1.34,0-1.29-.9-1.93-2.67-1.93h-.45v-1.76h.45c.77,0,1.39-.17,1.85-.51s.68-.8.68-1.36c0-.53-.2-.97-.6-1.31-.38-.34-.9-.51-1.53-.51s-1.19.19-1.56.57c-.36.36-.54.91-.54,1.65h-2.16c0-1.25.38-2.22,1.14-2.93.77-.72,1.85-1.08,3.21-1.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.34,566.18c.81,0,1.52.14,2.13.43.63.28,1.11.7,1.45,1.22.34.51.51,1.12.51,1.82s-.14,1.28-.4,1.79c-.25.5-.6.93-1.05,1.31-.45.36-1.05.75-1.79,1.17-.78.45-1.36.85-1.76,1.17-.4.33-.68.63-.82.91-.16.28-.24.6-.26.94h6.37v1.79h-8.84v-.37c0-.85.09-1.57.28-2.16.18-.58.54-1.14,1.05-1.68.51-.55,1.25-1.09,2.22-1.65.7-.4,1.23-.74,1.59-1.02.38-.28.67-.58.88-.91.21-.34.31-.74.31-1.19,0-.53-.17-.95-.51-1.25-.34-.32-.8-.48-1.36-.48-1.36,0-2.07.72-2.13,2.16h-2.16c.01-1.26.41-2.25,1.17-2.93.75-.7,1.8-1.05,3.13-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.91,566.18c1.51,0,2.67.56,3.47,1.68.8,1.1,1.19,2.67,1.19,4.72s-.4,3.66-1.19,4.78c-.8,1.1-1.95,1.65-3.47,1.65s-2.66-.55-3.47-1.65c-.8-1.12-1.19-2.71-1.19-4.78s.4-3.62,1.19-4.72c.81-1.12,1.97-1.68,3.47-1.68Zm0,1.85c-.78,0-1.39.39-1.82,1.17-.42.78-.63,1.9-.63,3.38s.21,2.61.63,3.41c.43.8,1.04,1.19,1.82,1.19s1.37-.4,1.79-1.19c.41-.8.63-1.93.63-3.41s-.21-2.6-.63-3.38c-.42-.77-1.02-1.17-1.79-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m513.47,566.18c1.51,0,2.67.56,3.47,1.68.8,1.1,1.19,2.67,1.19,4.72s-.4,3.66-1.19,4.78c-.8,1.1-1.95,1.65-3.47,1.65s-2.66-.55-3.47-1.65c-.8-1.12-1.19-2.71-1.19-4.78s.4-3.62,1.19-4.72c.81-1.12,1.97-1.68,3.47-1.68Zm0,1.85c-.78,0-1.39.39-1.82,1.17-.42.78-.63,1.9-.63,3.38s.21,2.61.63,3.41c.43.8,1.04,1.19,1.82,1.19s1.37-.4,1.79-1.19c.41-.8.63-1.93.63-3.41s-.21-2.6-.63-3.38c-.42-.77-1.02-1.17-1.79-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.05,575.76v2.96h-2.16v-2.96h-5.83v-1.85l5.12-7.45h2.87v7.59h1.88v1.71h-1.88Zm-2.1-1.71v-1.59c0-1.26.03-2.71.09-4.32h-.03c-.59.97-1.47,2.32-2.64,4.04l-1.28,1.88h3.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.85,574.25v-1.71h4.55v1.71h-4.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m540.24,566.18c1.51,0,2.67.56,3.47,1.68.8,1.1,1.19,2.67,1.19,4.72s-.4,3.66-1.19,4.78c-.8,1.1-1.95,1.65-3.47,1.65s-2.66-.55-3.47-1.65c-.8-1.12-1.19-2.71-1.19-4.78s.4-3.62,1.19-4.72c.81-1.12,1.97-1.68,3.47-1.68Zm0,1.85c-.78,0-1.39.39-1.82,1.17-.42.78-.63,1.9-.63,3.38s.21,2.61.63,3.41c.43.8,1.04,1.19,1.82,1.19s1.37-.4,1.79-1.19c.41-.8.63-1.93.63-3.41s-.21-2.6-.63-3.38c-.42-.77-1.02-1.17-1.79-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m550.8,566.18c.81,0,1.54.14,2.19.43.64.27,1.14.65,1.51,1.17.36.51.54,1.1.54,1.76s-.2,1.27-.6,1.76c-.38.48-.91.82-1.59,1.02v.06c.75.21,1.35.58,1.79,1.11.43.53.65,1.18.65,1.93s-.19,1.36-.57,1.9c-.36.53-.88.95-1.56,1.25-.68.28-1.47.43-2.36.43s-1.68-.14-2.36-.43c-.67-.3-1.19-.72-1.56-1.25-.38-.55-.57-1.18-.57-1.9s.21-1.4.65-1.93c.43-.53,1.03-.9,1.79-1.11v-.06c-.68-.21-1.22-.55-1.62-1.02-.38-.49-.57-1.08-.57-1.76s.18-1.25.54-1.76c.38-.51.88-.9,1.51-1.17.64-.28,1.37-.43,2.19-.43Zm0,1.79c-.65,0-1.17.16-1.56.48-.38.31-.57.72-.57,1.25,0,.57.18,1.02.57,1.34.38.33.9.48,1.56.48s1.18-.16,1.56-.48c.38-.32.57-.77.57-1.34,0-.53-.2-.95-.6-1.25-.38-.32-.9-.48-1.53-.48Zm0,5.32c-.68,0-1.24.18-1.68.54-.42.34-.63.81-.63,1.39s.2,1.07.6,1.42c.41.36.98.54,1.71.54s1.26-.18,1.68-.54c.43-.36.65-.83.65-1.42s-.22-1.03-.65-1.39c-.42-.36-.98-.54-1.68-.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m616.05,566.18c.81,0,1.52.14,2.13.43.63.28,1.11.7,1.45,1.22.34.51.51,1.12.51,1.82s-.14,1.28-.4,1.79c-.25.5-.6.93-1.05,1.31-.45.36-1.05.75-1.79,1.17-.78.45-1.36.85-1.76,1.17-.4.33-.68.63-.82.91-.16.28-.24.6-.26.94h6.37v1.79h-8.84v-.37c0-.85.09-1.57.28-2.16.18-.58.54-1.14,1.05-1.68.51-.55,1.25-1.09,2.22-1.65.7-.4,1.23-.74,1.59-1.02.38-.28.67-.58.88-.91.21-.34.31-.74.31-1.19,0-.53-.17-.95-.51-1.25-.34-.32-.8-.48-1.36-.48-1.36,0-2.07.72-2.13,2.16h-2.16c.01-1.26.41-2.25,1.17-2.93.75-.7,1.8-1.05,3.13-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.62,566.18c1.51,0,2.67.56,3.47,1.68.8,1.1,1.19,2.67,1.19,4.72s-.4,3.66-1.19,4.78c-.8,1.1-1.95,1.65-3.47,1.65s-2.66-.55-3.47-1.65c-.8-1.12-1.19-2.71-1.19-4.78s.4-3.62,1.19-4.72c.81-1.12,1.97-1.68,3.47-1.68Zm0,1.85c-.78,0-1.39.39-1.82,1.17-.42.78-.63,1.9-.63,3.38s.21,2.61.63,3.41c.43.8,1.04,1.19,1.82,1.19s1.37-.4,1.79-1.19c.41-.8.63-1.93.63-3.41s-.21-2.6-.63-3.38c-.42-.77-1.02-1.17-1.79-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m637.18,566.18c1.51,0,2.67.56,3.47,1.68.8,1.1,1.19,2.67,1.19,4.72s-.4,3.66-1.19,4.78c-.8,1.1-1.95,1.65-3.47,1.65s-2.66-.55-3.47-1.65c-.8-1.12-1.19-2.71-1.19-4.78s.4-3.62,1.19-4.72c.81-1.12,1.97-1.68,3.47-1.68Zm0,1.85c-.78,0-1.39.39-1.82,1.17-.42.78-.63,1.9-.63,3.38s.21,2.61.63,3.41c.43.8,1.04,1.19,1.82,1.19s1.37-.4,1.79-1.19c.41-.8.63-1.93.63-3.41s-.21-2.6-.63-3.38c-.42-.77-1.02-1.17-1.79-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m647.09,579c-1.14,0-2.06-.31-2.76-.94-.7-.63-1.09-1.49-1.17-2.61h2.19c.07.59.27,1.02.6,1.31.32.28.74.43,1.25.43.8,0,1.43-.34,1.9-1.02.49-.68.75-1.72.8-3.13h-.06c-.74.95-1.71,1.42-2.9,1.42-.78,0-1.47-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.57.54-2.22.38-.64.9-1.14,1.56-1.51.68-.36,1.45-.54,2.3-.54,1.46,0,2.57.5,3.35,1.51.77,1.01,1.17,2.5,1.17,4.49,0,2.18-.43,3.87-1.28,5.06-.84,1.18-2.02,1.76-3.55,1.76Zm.28-6.22c.64,0,1.17-.23,1.56-.68s.6-1.03.6-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.59.65c-.38.44-.57,1.02-.57,1.76s.18,1.3.57,1.73c.38.44.9.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m653.56,574.25v-1.71h4.55v1.71h-4.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m663.32,578.72v-8.61h-2.84v-1.56c.98,0,1.71-.16,2.19-.48.49-.32.8-.85.91-1.59h1.9v12.25h-2.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m674.48,566.18c1.29,0,2.3.31,3.04.94.75.61,1.14,1.44,1.14,2.47,0,.7-.17,1.28-.51,1.73-.34.44-.88.79-1.62,1.05v.06c.81.27,1.4.65,1.76,1.14.38.48.57,1.1.57,1.88,0,.72-.18,1.35-.54,1.88-.36.53-.87.95-1.53,1.25-.67.28-1.42.43-2.27.43-1.44,0-2.55-.36-3.33-1.08-.78-.72-1.17-1.74-1.17-3.07h2.16c0,.78.18,1.36.57,1.76.4.38.98.57,1.76.57.64,0,1.17-.16,1.56-.48.4-.34.6-.78.6-1.34,0-1.29-.9-1.93-2.67-1.93h-.45v-1.76h.45c.77,0,1.39-.17,1.85-.51s.68-.8.68-1.36c0-.53-.2-.97-.6-1.31-.38-.34-.9-.51-1.53-.51s-1.19.19-1.56.57c-.36.36-.54.91-.54,1.65h-2.16c0-1.25.38-2.22,1.14-2.93.77-.72,1.85-1.08,3.21-1.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m739.76,566.18c.81,0,1.52.14,2.13.43.63.28,1.11.7,1.45,1.22.34.51.51,1.12.51,1.82s-.14,1.28-.4,1.79c-.25.5-.6.93-1.05,1.31-.45.36-1.05.75-1.79,1.17-.78.45-1.36.85-1.76,1.17-.4.33-.68.63-.82.91-.16.28-.24.6-.26.94h6.37v1.79h-8.84v-.37c0-.85.09-1.57.28-2.16.18-.58.54-1.14,1.05-1.68.51-.55,1.25-1.09,2.22-1.65.7-.4,1.23-.74,1.59-1.02.38-.28.67-.58.88-.91.21-.34.31-.74.31-1.19,0-.53-.17-.95-.51-1.25-.34-.32-.8-.48-1.36-.48-1.36,0-2.07.72-2.13,2.16h-2.16c.01-1.26.41-2.25,1.17-2.93.75-.7,1.8-1.05,3.13-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m750.33,566.18c1.51,0,2.67.56,3.47,1.68.8,1.1,1.19,2.67,1.19,4.72s-.4,3.66-1.19,4.78c-.8,1.1-1.95,1.65-3.47,1.65s-2.66-.55-3.47-1.65c-.8-1.12-1.19-2.71-1.19-4.78s.4-3.62,1.19-4.72c.81-1.12,1.97-1.68,3.47-1.68Zm0,1.85c-.78,0-1.39.39-1.82,1.17-.42.78-.63,1.9-.63,3.38s.21,2.61.63,3.41c.43.8,1.04,1.19,1.82,1.19s1.37-.4,1.79-1.19c.41-.8.63-1.93.63-3.41s-.21-2.6-.63-3.38c-.42-.77-1.02-1.17-1.79-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m760.27,578.72v-8.61h-2.84v-1.56c.98,0,1.71-.16,2.19-.48.49-.32.8-.85.91-1.59h1.9v12.25h-2.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m774.47,575.76v2.96h-2.16v-2.96h-5.83v-1.85l5.12-7.45h2.87v7.59h1.88v1.71h-1.88Zm-2.1-1.71v-1.59c0-1.26.03-2.71.09-4.32h-.03c-.59.97-1.47,2.32-2.64,4.04l-1.28,1.88h3.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m777.28,574.25v-1.71h4.55v1.71h-4.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m787.03,578.72v-8.61h-2.84v-1.56c.98,0,1.71-.16,2.19-.48.49-.32.8-.85.91-1.59h1.9v12.25h-2.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m798.22,566.18c.81,0,1.54.14,2.19.43.64.27,1.14.65,1.51,1.17.36.51.54,1.1.54,1.76s-.2,1.27-.6,1.76c-.38.48-.91.82-1.59,1.02v.06c.75.21,1.35.58,1.79,1.11.43.53.65,1.18.65,1.93s-.19,1.36-.57,1.9c-.36.53-.88.95-1.56,1.25-.68.28-1.47.43-2.36.43s-1.68-.14-2.36-.43c-.67-.3-1.19-.72-1.56-1.25-.38-.55-.57-1.18-.57-1.9s.21-1.4.65-1.93c.43-.53,1.03-.9,1.79-1.11v-.06c-.68-.21-1.22-.55-1.62-1.02-.38-.49-.57-1.08-.57-1.76s.18-1.25.54-1.76c.38-.51.88-.9,1.51-1.17.64-.28,1.37-.43,2.19-.43Zm0,1.79c-.65,0-1.17.16-1.56.48-.38.31-.57.72-.57,1.25,0,.57.18,1.02.57,1.34.38.33.9.48,1.56.48s1.18-.16,1.56-.48c.38-.32.57-.77.57-1.34,0-.53-.2-.95-.6-1.25-.38-.32-.9-.48-1.53-.48Zm0,5.32c-.68,0-1.24.18-1.68.54-.42.34-.63.81-.63,1.39s.2,1.07.6,1.42c.41.36.98.54,1.71.54s1.26-.18,1.68-.54c.43-.36.65-.83.65-1.42s-.22-1.03-.65-1.39c-.42-.36-.98-.54-1.68-.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m863.48,566.18c.81,0,1.52.14,2.13.43.63.28,1.11.7,1.45,1.22.34.51.51,1.12.51,1.82s-.14,1.28-.4,1.79c-.25.5-.6.93-1.05,1.31-.45.36-1.05.75-1.79,1.17-.78.45-1.36.85-1.76,1.17-.4.33-.68.63-.82.91-.16.28-.24.6-.26.94h6.37v1.79h-8.84v-.37c0-.85.09-1.57.28-2.16.18-.58.54-1.14,1.05-1.68.51-.55,1.25-1.09,2.22-1.65.7-.4,1.23-.74,1.59-1.02.38-.28.67-.58.88-.91.21-.34.31-.74.31-1.19,0-.53-.17-.95-.51-1.25-.34-.32-.8-.48-1.36-.48-1.36,0-2.07.72-2.13,2.16h-2.16c.01-1.26.41-2.25,1.17-2.93.75-.7,1.8-1.05,3.13-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m874.04,566.18c1.51,0,2.67.56,3.47,1.68.8,1.1,1.19,2.67,1.19,4.72s-.4,3.66-1.19,4.78c-.8,1.1-1.95,1.65-3.47,1.65s-2.66-.55-3.47-1.65c-.8-1.12-1.19-2.71-1.19-4.78s.4-3.62,1.19-4.72c.81-1.12,1.97-1.68,3.47-1.68Zm0,1.85c-.78,0-1.39.39-1.82,1.17-.42.78-.63,1.9-.63,3.38s.21,2.61.63,3.41c.43.8,1.04,1.19,1.82,1.19s1.37-.4,1.79-1.19c.41-.8.63-1.93.63-3.41s-.21-2.6-.63-3.38c-.42-.77-1.02-1.17-1.79-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m883.98,578.72v-8.61h-2.84v-1.56c.98,0,1.71-.16,2.19-.48.49-.32.8-.85.91-1.59h1.9v12.25h-2.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m894.52,579c-1.14,0-2.06-.31-2.76-.94-.7-.63-1.09-1.49-1.17-2.61h2.19c.07.59.27,1.02.6,1.31.32.28.74.43,1.25.43.8,0,1.43-.34,1.9-1.02.49-.68.75-1.72.8-3.13h-.06c-.74.95-1.71,1.42-2.9,1.42-.78,0-1.47-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.57.54-2.22.38-.64.9-1.14,1.56-1.51.68-.36,1.45-.54,2.3-.54,1.46,0,2.57.5,3.35,1.51.77,1.01,1.17,2.5,1.17,4.49,0,2.18-.43,3.87-1.28,5.06-.84,1.18-2.02,1.76-3.55,1.76Zm.28-6.22c.64,0,1.17-.23,1.56-.68s.6-1.03.6-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.59.65c-.38.44-.57,1.02-.57,1.76s.18,1.3.57,1.73c.38.44.9.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m900.99,574.25v-1.71h4.55v1.71h-4.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m911.37,566.18c.81,0,1.52.14,2.13.43.63.28,1.11.7,1.45,1.22.34.51.51,1.12.51,1.82s-.14,1.28-.4,1.79c-.25.5-.6.93-1.05,1.31-.45.36-1.05.75-1.79,1.17-.78.45-1.36.85-1.76,1.17-.4.33-.68.63-.82.91-.16.28-.24.6-.26.94h6.37v1.79h-8.84v-.37c0-.85.09-1.57.28-2.16.18-.58.54-1.14,1.05-1.68.51-.55,1.25-1.09,2.22-1.65.7-.4,1.23-.74,1.59-1.02.38-.28.67-.58.88-.91.21-.34.31-.74.31-1.19,0-.53-.17-.95-.51-1.25-.34-.32-.8-.48-1.36-.48-1.36,0-2.07.72-2.13,2.16h-2.16c.01-1.26.41-2.25,1.17-2.93.75-.7,1.8-1.05,3.13-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m921.91,566.18c1.29,0,2.3.31,3.04.94.75.61,1.14,1.44,1.14,2.47,0,.7-.17,1.28-.51,1.73-.34.44-.88.79-1.62,1.05v.06c.81.27,1.4.65,1.76,1.14.38.48.57,1.1.57,1.88,0,.72-.18,1.35-.54,1.88-.36.53-.87.95-1.53,1.25-.67.28-1.42.43-2.27.43-1.44,0-2.55-.36-3.33-1.08-.78-.72-1.17-1.74-1.17-3.07h2.16c0,.78.18,1.36.57,1.76.4.38.98.57,1.76.57.64,0,1.17-.16,1.56-.48.4-.34.6-.78.6-1.34,0-1.29-.9-1.93-2.67-1.93h-.45v-1.76h.45c.77,0,1.39-.17,1.85-.51s.68-.8.68-1.36c0-.53-.2-.97-.6-1.31-.38-.34-.9-.51-1.53-.51s-1.19.19-1.56.57c-.36.36-.54.91-.54,1.65h-2.16c0-1.25.38-2.22,1.14-2.93.77-.72,1.85-1.08,3.21-1.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 213.6,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-4)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      mask: "url(#mask)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.47,
    y: 213.01,
    width: 867.69,
    height: 3.64,
    style: {
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-5)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 213.6,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-6)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.58,213.6h866.32v341.07H88.58V213.6Z",
    style: {
      fill: "#474747"
    }
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 298.45,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-7)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      mask: "url(#mask-1)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.47,
    y: 296.68,
    width: 867.69,
    height: 3.64,
    style: {
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-8)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 298.45,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-9)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.58,213.6h866.32v341.07H88.58V213.6Z",
    style: {
      fill: "#474747"
    }
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 383.31,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-10)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      mask: "url(#mask-2)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.47,
    y: 382.18,
    width: 867.69,
    height: 3.64,
    style: {
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-11)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 383.31,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-12)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.58,213.6h866.32v341.07H88.58V213.6Z",
    style: {
      fill: "#474747"
    }
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 468.16,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-13)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      mask: "url(#mask-3)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.47,
    y: 467.67,
    width: 867.69,
    height: 3.64,
    style: {
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-14)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 468.16,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-15)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.58,213.6h866.32v341.07H88.58V213.6Z",
    style: {
      fill: "#474747"
    }
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 553.03,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-16)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      mask: "url(#mask-4)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.47,
    y: 551.35,
    width: 867.69,
    height: 3.64,
    style: {
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-17)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 553.03,
    width: 865.98,
    height: 1.36,
    style: {
      fill: "#474747"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-18)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.58,213.6h866.32v341.07H88.58V213.6Z",
    style: {
      fill: "#474747"
    }
  })))))))), /*#__PURE__*/React.createElement("path", {
    d: "m48.28,219.73v-8.61h-2.84v-1.56c.98,0,1.71-.16,2.19-.48.49-.32.8-.85.91-1.59h1.9v12.25h-2.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.47,207.2c1.51,0,2.67.56,3.47,1.68.8,1.1,1.19,2.67,1.19,4.72s-.4,3.66-1.19,4.78c-.8,1.1-1.95,1.65-3.47,1.65s-2.66-.55-3.47-1.65c-.8-1.12-1.19-2.71-1.19-4.78s.4-3.62,1.19-4.72c.81-1.12,1.97-1.68,3.47-1.68Zm0,1.85c-.78,0-1.39.39-1.82,1.17-.42.78-.63,1.9-.63,3.38s.21,2.61.63,3.41c.43.8,1.04,1.19,1.82,1.19s1.37-.4,1.79-1.19c.41-.8.63-1.93.63-3.41s-.21-2.6-.63-3.38c-.42-.77-1.02-1.17-1.79-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.03,207.2c1.51,0,2.67.56,3.47,1.68.8,1.1,1.19,2.67,1.19,4.72s-.4,3.66-1.19,4.78c-.8,1.1-1.95,1.65-3.47,1.65s-2.66-.55-3.47-1.65c-.8-1.12-1.19-2.71-1.19-4.78s.4-3.62,1.19-4.72c.81-1.12,1.97-1.68,3.47-1.68Zm0,1.85c-.78,0-1.39.39-1.82,1.17-.42.78-.63,1.9-.63,3.38s.21,2.61.63,3.41c.43.8,1.04,1.19,1.82,1.19s1.37-.4,1.79-1.19c.41-.8.63-1.93.63-3.41s-.21-2.6-.63-3.38c-.42-.77-1.02-1.17-1.79-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.79,294.22c-.95,1.35-1.79,2.91-2.53,4.69-.72,1.78-1.26,3.68-1.62,5.68h-2.36c.47-2.2,1.09-4.19,1.88-5.97.8-1.8,1.63-3.28,2.5-4.46h-6.68v-1.82h8.81v1.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.21,294.1l-.34,3.33h.03c.3-.3.66-.53,1.08-.68.43-.17.89-.26,1.36-.26.8,0,1.49.17,2.1.51.63.33,1.09.8,1.42,1.42.34.61.51,1.31.51,2.1,0,.87-.19,1.64-.57,2.3-.36.65-.88,1.15-1.56,1.51-.68.36-1.48.54-2.39.54-1.27,0-2.29-.32-3.04-.97-.76-.64-1.14-1.51-1.14-2.61h2.16c.01.55.21.99.6,1.31.38.31.85.45,1.42.45.72,0,1.28-.21,1.68-.63.4-.43.6-1.04.6-1.82s-.2-1.34-.6-1.76c-.38-.41-.91-.63-1.59-.63-.53,0-.98.14-1.34.4-.34.27-.58.64-.71,1.11l-2.13-.14.71-7.25h7.3v1.76h-5.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.65,378.96l-.34,3.33h.03c.3-.3.66-.53,1.08-.68.43-.17.89-.26,1.36-.26.8,0,1.49.17,2.1.51.63.33,1.09.8,1.42,1.42.34.61.51,1.31.51,2.1,0,.87-.19,1.64-.57,2.3-.36.65-.88,1.15-1.56,1.51-.68.36-1.48.54-2.39.54-1.27,0-2.29-.32-3.04-.97-.76-.64-1.14-1.51-1.14-2.61h2.16c.01.55.21.99.6,1.31.38.31.85.45,1.42.45.72,0,1.28-.21,1.68-.63.4-.43.6-1.04.6-1.82s-.2-1.34-.6-1.76c-.38-.41-.91-.63-1.59-.63-.53,0-.98.14-1.34.4-.34.27-.58.64-.71,1.11l-2.13-.14.71-7.25h7.3v1.76h-5.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.03,376.91c1.51,0,2.67.56,3.47,1.68.8,1.1,1.19,2.67,1.19,4.72s-.4,3.66-1.19,4.78c-.8,1.1-1.95,1.65-3.47,1.65s-2.66-.55-3.47-1.65c-.8-1.12-1.19-2.71-1.19-4.78s.4-3.62,1.19-4.72c.81-1.12,1.97-1.68,3.47-1.68Zm0,1.85c-.78,0-1.39.39-1.82,1.17-.42.78-.63,1.9-.63,3.38s.21,2.61.63,3.41c.43.8,1.04,1.19,1.82,1.19s1.37-.4,1.79-1.19c.41-.8.63-1.93.63-3.41s-.21-2.6-.63-3.38c-.42-.77-1.02-1.17-1.79-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.47,461.77c.81,0,1.52.14,2.13.43.63.28,1.11.7,1.45,1.22.34.51.51,1.12.51,1.82s-.14,1.28-.4,1.79c-.25.5-.6.93-1.05,1.31-.45.36-1.05.75-1.79,1.17-.78.45-1.36.85-1.76,1.17-.4.33-.68.63-.82.91-.16.28-.24.6-.26.94h6.37v1.79h-8.84v-.37c0-.85.09-1.57.28-2.16.18-.58.54-1.14,1.05-1.68.51-.55,1.25-1.09,2.22-1.65.7-.4,1.23-.74,1.59-1.02.38-.28.67-.58.88-.91.21-.34.31-.74.31-1.19,0-.53-.17-.95-.51-1.25-.34-.32-.8-.48-1.36-.48-1.36,0-2.07.72-2.13,2.16h-2.16c.01-1.26.41-2.25,1.17-2.93.75-.7,1.8-1.05,3.13-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.21,463.82l-.34,3.33h.03c.3-.3.66-.53,1.08-.68.43-.17.89-.26,1.36-.26.8,0,1.49.17,2.1.51.63.33,1.09.8,1.42,1.42.34.61.51,1.31.51,2.1,0,.87-.19,1.64-.57,2.3-.36.65-.88,1.15-1.56,1.51-.68.36-1.48.54-2.39.54-1.27,0-2.29-.32-3.04-.97-.76-.64-1.14-1.51-1.14-2.61h2.16c.01.55.21.99.6,1.31.38.31.85.45,1.42.45.72,0,1.28-.21,1.68-.63.4-.43.6-1.04.6-1.82s-.2-1.34-.6-1.76c-.38-.41-.91-.63-1.59-.63-.53,0-.98.14-1.34.4-.34.27-.58.64-.71,1.11l-2.13-.14.71-7.25h7.3v1.76h-5.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.03,546.63c1.51,0,2.67.56,3.47,1.68.8,1.1,1.19,2.67,1.19,4.72s-.4,3.66-1.19,4.78c-.8,1.1-1.95,1.65-3.47,1.65s-2.66-.55-3.47-1.65c-.8-1.12-1.19-2.71-1.19-4.78s.4-3.62,1.19-4.72c.81-1.12,1.97-1.68,3.47-1.68Zm0,1.85c-.78,0-1.39.39-1.82,1.17-.42.78-.63,1.9-.63,3.38s.21,2.61.63,3.41c.43.8,1.04,1.19,1.82,1.19s1.37-.4,1.79-1.19c.41-.8.63-1.93.63-3.41s-.21-2.6-.63-3.38c-.42-.77-1.02-1.17-1.79-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-19)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-20)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.61,207.46h755.81v353.35H143.61V207.46Z",
    style: {
      fill: "#ff5722"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-21)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-22)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.61,207.46h755.81v353.35H143.61V207.46Z",
    style: {
      fill: "#ff5722"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-23)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-24)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.61,207.46h755.81v353.35H143.61V207.46Z",
    style: {
      fill: "#ff5722"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-25)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-26)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.61,207.46h755.81v353.35H143.61V207.46Z",
    style: {
      fill: "#ff5722"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-27)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-28)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.61,207.46h755.81v353.35H143.61V207.46Z",
    style: {
      fill: "#ff5722"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-29)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-30)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.61,207.46h755.81v353.35H143.61V207.46Z",
    style: {
      fill: "#ff5722"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-31)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-32)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.61,207.46h755.81v353.35H143.61V207.46Z",
    style: {
      fill: "#9d22ff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-33)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-34)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.61,207.46h755.81v353.35H143.61V207.46Z",
    style: {
      fill: "#9d22ff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-35)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-36)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.61,207.46h755.81v353.35H143.61V207.46Z",
    style: {
      fill: "#9d22ff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-37)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-38)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.61,207.46h755.81v353.35H143.61V207.46Z",
    style: {
      fill: "#9d22ff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-39)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-40)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.61,207.46h755.81v353.35H143.61V207.46Z",
    style: {
      fill: "#9d22ff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-41)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-42)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.61,207.46h755.81v353.35H143.61V207.46Z",
    style: {
      fill: "#9d22ff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m322.89,29.83c2.05,0,3.84.41,5.4,1.22,1.57.8,2.79,1.9,3.64,3.33.87,1.42,1.35,3.06,1.45,4.89h-4.38c-.21-1.72-.85-3.08-1.93-4.06-1.08-.98-2.47-1.48-4.18-1.48-2.22,0-3.96.87-5.23,2.59-1.25,1.71-1.88,4.05-1.88,7.02s.63,5.34,1.88,7.05,2.96,2.56,5.12,2.56c1.72,0,3.13-.49,4.23-1.48,1.09-1,1.77-2.39,2.02-4.15h4.46c-.27,2.98-1.35,5.31-3.24,6.99-1.88,1.69-4.37,2.53-7.48,2.53-2.35,0-4.4-.54-6.14-1.62-1.75-1.09-3.08-2.66-4.01-4.69-.91-2.03-1.36-4.42-1.36-7.19s.46-5.15,1.39-7.16c.95-2.03,2.29-3.59,4.04-4.69,1.74-1.09,3.81-1.65,6.2-1.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.73,56.29v-25.89h4.15v25.89h-4.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.12,37.28c2.46,0,4.33.61,5.63,1.82,1.31,1.22,1.96,3.01,1.96,5.4v6.91c0,1.99.16,3.62.48,4.89h-3.75c-.17-.75-.26-1.62-.26-2.59h-.09c-1.35,1.99-3.41,2.98-6.2,2.98-1.9,0-3.42-.51-4.58-1.53-1.14-1.04-1.71-2.36-1.71-3.95s.54-2.83,1.62-3.78c1.08-.95,2.91-1.63,5.49-2.05,1.55-.26,3.21-.44,4.97-.54v-.74c0-1.31-.33-2.26-.97-2.87-.63-.63-1.5-.94-2.61-.94s-2,.3-2.64.88c-.63.57-.96,1.36-.99,2.36h-4.09c.09-1.85.8-3.36,2.13-4.52,1.32-1.15,3.19-1.73,5.6-1.73Zm3.58,10.26c-1.58.1-2.98.25-4.23.45-1.35.23-2.3.56-2.84.99-.53.44-.8,1.08-.8,1.93s.28,1.48.85,1.99c.57.5,1.37.74,2.42.74.64,0,1.26-.1,1.85-.31.58-.21,1.09-.52,1.51-.94.47-.51.8-1.05.97-1.62.18-.57.28-1.34.28-2.33v-.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.79,56.29v-18.47h4.15v18.47h-4.15Zm0-21.94v-3.95h4.15v3.95h-4.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.82,37.36c1.99,0,3.53.65,4.63,1.93,1.12,1.29,1.68,3.15,1.68,5.6v11.4h-4.15v-11c0-3.05-1.11-4.58-3.33-4.58-1.22,0-2.17.5-2.87,1.48-.68.99-1.02,2.36-1.02,4.12v9.98h-4.15v-11.43c0-1.31-.28-2.32-.85-3.04-.57-.74-1.39-1.11-2.47-1.11-1.24,0-2.19.5-2.87,1.51-.68.99-1.02,2.38-1.02,4.18v9.89h-4.15v-18.47h3.98v2.22h.09c.64-.91,1.38-1.58,2.22-2.02.83-.43,1.8-.65,2.9-.65,1.29,0,2.4.3,3.35.88.95.57,1.65,1.39,2.1,2.47.7-1.08,1.52-1.9,2.47-2.47.95-.58,2.1-.88,3.47-.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.61,37.28c2.39,0,4.22.54,5.51,1.62,1.31,1.07,1.97,2.61,1.99,4.66h-4.01c0-1.09-.31-1.91-.91-2.44-.61-.55-1.48-.82-2.61-.82-.97,0-1.72.2-2.25.6-.53.38-.8.91-.8,1.59,0,.5.13.9.4,1.19.28.31.69.55,1.22.74.53.19,1.38.43,2.56.71,1.59.42,2.83.81,3.72,1.17.89.34,1.66.91,2.3,1.71.64.78.97,1.85.97,3.21,0,1.69-.71,3.06-2.13,4.09-1.41,1.02-3.28,1.53-5.63,1.53-2.52,0-4.48-.55-5.88-1.68-1.39-1.14-2.1-2.79-2.13-4.95h4.23c0,1.14.33,2.01.99,2.61.66.61,1.62.91,2.87.91,1.04,0,1.85-.2,2.44-.6.58-.41.88-.97.88-1.68,0-.6-.16-1.08-.48-1.42-.31-.36-.76-.64-1.36-.85-.59-.21-1.53-.47-2.81-.8-1.42-.36-2.54-.69-3.35-.99-.82-.32-1.52-.84-2.1-1.56-.57-.74-.85-1.75-.85-3.04,0-1.08.3-2.03.91-2.87.6-.85,1.45-1.51,2.53-1.96,1.09-.45,2.36-.68,3.78-.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.22,29.83c3.13,0,5.49.73,7.11,2.19,1.61,1.44,2.42,3.55,2.42,6.34h-4.41c0-1.63-.45-2.86-1.36-3.69-.9-.83-2.17-1.25-3.84-1.25-1.41,0-2.52.31-3.33.94-.82.61-1.22,1.44-1.22,2.5,0,.78.2,1.41.6,1.88.4.48,1,.88,1.82,1.22.81.33,1.99.67,3.52,1.02,1.99.5,3.59,1.01,4.8,1.53,1.23.51,2.22,1.28,2.98,2.3.77,1.01,1.17,2.37,1.17,4.09,0,1.58-.41,2.97-1.22,4.18-.8,1.19-1.93,2.12-3.41,2.79-1.46.64-3.15.97-5.06.97-3.18,0-5.66-.77-7.42-2.33-1.76-1.57-2.64-3.82-2.64-6.76h4.46c0,1.82.48,3.2,1.45,4.12.97.91,2.36,1.36,4.18,1.36,1.61,0,2.87-.35,3.78-1.05.91-.7,1.36-1.66,1.36-2.87,0-.85-.21-1.51-.63-1.99-.42-.49-1.01-.88-1.76-1.17-.76-.28-1.92-.63-3.47-1.02-2.05-.51-3.68-1.02-4.89-1.53-1.22-.51-2.2-1.26-2.96-2.27-.76-1-1.14-2.34-1.14-4.04,0-1.46.37-2.74,1.11-3.87.75-1.14,1.82-2.02,3.18-2.64,1.38-.63,2.98-.94,4.8-.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464.24,56.72c-2.15,0-3.8-.63-4.97-1.9-1.18-1.29-1.76-3.18-1.76-5.68v-11.31h4.15v10.94c0,3.09,1.25,4.63,3.75,4.63,1.23,0,2.23-.46,3.01-1.39.8-.92,1.19-2.23,1.19-3.92v-10.26h4.15v18.47h-3.92v-2.39h-.09c-.61.87-1.39,1.56-2.33,2.07-.93.49-1.99.74-3.18.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.78,37.28c1.55,0,2.93.31,4.15.94,1.21.61,2.17,1.46,2.9,2.56.74,1.08,1.17,2.32,1.28,3.72h-4.32c-.11-1.21-.53-2.17-1.25-2.87-.72-.72-1.64-1.08-2.76-1.08-1.46,0-2.6.58-3.41,1.73-.82,1.14-1.22,2.73-1.22,4.78s.41,3.62,1.22,4.78c.81,1.16,1.95,1.73,3.41,1.73,1.12,0,2.03-.4,2.73-1.19.72-.8,1.12-1.83,1.22-3.1h4.38c-.19,2.26-1.04,4.09-2.56,5.49-1.5,1.39-3.42,2.07-5.77,2.07-1.8,0-3.38-.4-4.75-1.19-1.35-.8-2.39-1.92-3.13-3.38-.74-1.48-1.11-3.21-1.11-5.2s.37-3.71,1.11-5.17c.74-1.48,1.78-2.61,3.13-3.41,1.36-.8,2.94-1.19,4.75-1.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.71,37.28c1.55,0,2.93.31,4.15.94,1.21.61,2.17,1.46,2.9,2.56.74,1.08,1.17,2.32,1.28,3.72h-4.32c-.11-1.21-.53-2.17-1.25-2.87-.72-.72-1.64-1.08-2.76-1.08-1.46,0-2.6.58-3.41,1.73-.82,1.14-1.22,2.73-1.22,4.78s.41,3.62,1.22,4.78c.81,1.16,1.95,1.73,3.41,1.73,1.12,0,2.03-.4,2.73-1.19.72-.8,1.12-1.83,1.22-3.1h4.38c-.19,2.26-1.04,4.09-2.56,5.49-1.5,1.39-3.42,2.07-5.77,2.07-1.8,0-3.38-.4-4.75-1.19-1.35-.8-2.39-1.92-3.13-3.38-.74-1.48-1.11-3.21-1.11-5.2s.37-3.71,1.11-5.17c.74-1.48,1.78-2.61,3.13-3.41,1.36-.8,2.94-1.19,4.75-1.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.61,53.79c1.15,0,2.1-.27,2.84-.82.74-.57,1.2-1.31,1.39-2.25h4.26c-.36,1.75-1.3,3.2-2.81,4.38-1.5,1.16-3.4,1.73-5.68,1.73-1.86,0-3.46-.42-4.8-1.25-1.35-.83-2.38-2-3.1-3.5-.7-1.51-1.05-3.27-1.05-5.26,0-1.82.35-3.45,1.05-4.89.7-1.46,1.72-2.59,3.07-3.41,1.34-.83,2.93-1.25,4.75-1.25,2.08,0,3.85.57,5.32,1.71,1.48,1.12,2.47,2.64,2.98,4.58.34,1.1.51,2.54.51,4.32h-13.59c.07,1.99.55,3.48,1.45,4.46.89.97,2.03,1.45,3.41,1.45Zm-.09-13.47c-1.29,0-2.35.42-3.18,1.25-.84.82-1.34,2.01-1.51,3.58h9.35c-.16-1.57-.65-2.76-1.48-3.58-.84-.83-1.9-1.25-3.18-1.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m545.72,37.28c2.39,0,4.22.54,5.51,1.62,1.31,1.07,1.97,2.61,1.99,4.66h-4.01c0-1.09-.31-1.91-.91-2.44-.61-.55-1.48-.82-2.61-.82-.97,0-1.72.2-2.25.6-.53.38-.8.91-.8,1.59,0,.5.13.9.4,1.19.28.31.69.55,1.22.74.53.19,1.38.43,2.56.71,1.59.42,2.83.81,3.72,1.17.89.34,1.66.91,2.3,1.71.64.78.97,1.85.97,3.21,0,1.69-.71,3.06-2.13,4.09-1.41,1.02-3.28,1.53-5.63,1.53-2.52,0-4.48-.55-5.88-1.68-1.39-1.14-2.1-2.79-2.13-4.95h4.23c0,1.14.33,2.01.99,2.61.66.61,1.62.91,2.87.91,1.04,0,1.85-.2,2.44-.6.58-.41.88-.97.88-1.68,0-.6-.16-1.08-.48-1.42-.31-.36-.76-.64-1.36-.85-.59-.21-1.53-.47-2.81-.8-1.42-.36-2.54-.69-3.35-.99-.82-.32-1.52-.84-2.1-1.56-.57-.74-.85-1.75-.85-3.04,0-1.08.3-2.03.91-2.87.6-.85,1.45-1.51,2.53-1.96,1.09-.45,2.36-.68,3.78-.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m564.23,37.28c2.39,0,4.22.54,5.51,1.62,1.31,1.07,1.97,2.61,1.99,4.66h-4.01c0-1.09-.31-1.91-.91-2.44-.61-.55-1.48-.82-2.61-.82-.97,0-1.72.2-2.25.6-.53.38-.8.91-.8,1.59,0,.5.13.9.4,1.19.28.31.69.55,1.22.74.53.19,1.38.43,2.56.71,1.59.42,2.83.81,3.72,1.17.89.34,1.66.91,2.3,1.71.64.78.97,1.85.97,3.21,0,1.69-.71,3.06-2.13,4.09-1.41,1.02-3.28,1.53-5.63,1.53-2.52,0-4.48-.55-5.88-1.68-1.39-1.14-2.1-2.79-2.13-4.95h4.23c0,1.14.33,2.01.99,2.61.66.61,1.62.91,2.87.91,1.04,0,1.85-.2,2.44-.6.58-.41.88-.97.88-1.68,0-.6-.16-1.08-.48-1.42-.31-.36-.76-.64-1.36-.85-.59-.21-1.53-.47-2.81-.8-1.42-.36-2.54-.69-3.35-.99-.82-.32-1.52-.84-2.1-1.56-.57-.74-.85-1.75-.85-3.04,0-1.08.3-2.03.91-2.87.6-.85,1.45-1.51,2.53-1.96,1.09-.45,2.36-.68,3.78-.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m595.31,34.18v22.11h-4.35v-22.11h-8.5v-3.78h21.35v3.78h-8.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m616.02,37.56c.49,0,1,.06,1.53.17v3.67c-.45-.09-.94-.14-1.45-.14-1.65,0-2.92.53-3.81,1.56-.9,1.02-1.34,2.49-1.34,4.41v9.07h-4.15v-18.47h3.87v2.73h.09c1.23-1.99,2.98-2.98,5.26-2.98Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m628.22,53.79c1.15,0,2.1-.27,2.84-.82.74-.57,1.2-1.31,1.39-2.25h4.26c-.36,1.75-1.3,3.2-2.81,4.38-1.5,1.16-3.4,1.73-5.68,1.73-1.86,0-3.46-.42-4.8-1.25-1.35-.83-2.38-2-3.1-3.5-.7-1.51-1.05-3.27-1.05-5.26,0-1.82.35-3.45,1.05-4.89.7-1.46,1.72-2.59,3.07-3.41,1.34-.83,2.93-1.25,4.75-1.25,2.08,0,3.85.57,5.32,1.71,1.48,1.12,2.47,2.64,2.98,4.58.34,1.1.51,2.54.51,4.32h-13.59c.07,1.99.55,3.48,1.45,4.46.89.97,2.03,1.45,3.41,1.45Zm-.09-13.47c-1.29,0-2.35.42-3.18,1.25-.84.82-1.34,2.01-1.51,3.58h9.35c-.16-1.57-.65-2.76-1.48-3.58-.84-.83-1.9-1.25-3.18-1.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m650.51,37.36c2.12,0,3.77.65,4.95,1.93,1.19,1.29,1.79,3.18,1.79,5.68v11.31h-4.15v-10.94c0-3.08-1.25-4.63-3.75-4.63-1.24,0-2.25.47-3.04,1.39-.8.91-1.19,2.22-1.19,3.92v10.26h-4.15v-18.47h3.95v2.39h.06c.6-.87,1.38-1.56,2.33-2.07.95-.51,2.02-.77,3.21-.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m674.36,56.29v-2.56h-.09c-.53.95-1.29,1.69-2.27,2.22-.99.51-2.06.77-3.21.77-1.56,0-2.92-.39-4.09-1.17-1.16-.8-2.05-1.92-2.67-3.38-.63-1.48-.94-3.18-.94-5.12s.31-3.65.94-5.12c.63-1.46,1.51-2.59,2.67-3.38,1.15-.81,2.51-1.22,4.06-1.22,1.15,0,2.2.26,3.15.77.97.51,1.71,1.22,2.25,2.1h.09v-9.81h4.15v25.89h-4.04Zm-4.38-15.72c-1.41,0-2.52.59-3.35,1.76-.82,1.18-1.22,2.75-1.22,4.72s.41,3.55,1.22,4.72c.83,1.18,1.95,1.76,3.35,1.76s2.45-.58,3.27-1.73c.81-1.17,1.22-2.76,1.22-4.75s-.41-3.59-1.22-4.75c-.82-1.15-1.9-1.73-3.27-1.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m690.06,37.28c2.39,0,4.22.54,5.51,1.62,1.31,1.07,1.97,2.61,1.99,4.66h-4.01c0-1.09-.31-1.91-.91-2.44-.61-.55-1.48-.82-2.61-.82-.97,0-1.72.2-2.25.6-.53.38-.8.91-.8,1.59,0,.5.13.9.4,1.19.28.31.69.55,1.22.74.53.19,1.38.43,2.56.71,1.59.42,2.83.81,3.72,1.17.89.34,1.66.91,2.3,1.71.64.78.97,1.85.97,3.21,0,1.69-.71,3.06-2.13,4.09-1.41,1.02-3.28,1.53-5.63,1.53-2.52,0-4.48-.55-5.88-1.68-1.39-1.14-2.1-2.79-2.13-4.95h4.23c0,1.14.33,2.01.99,2.61.66.61,1.62.91,2.87.91,1.04,0,1.85-.2,2.44-.6.58-.41.88-.97.88-1.68,0-.6-.16-1.08-.48-1.42-.31-.36-.76-.64-1.36-.85-.59-.21-1.53-.47-2.81-.8-1.42-.36-2.54-.69-3.35-.99-.82-.32-1.52-.84-2.1-1.56-.57-.74-.85-1.75-.85-3.04,0-1.08.3-2.03.91-2.87.6-.85,1.45-1.51,2.53-1.96,1.09-.45,2.36-.68,3.78-.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.89,98.04l10.29-20.04h2.05l-10.29,20.04h-2.05Zm-.34-19.61c1.38,0,2.44.47,3.18,1.39.75.91,1.14,2.21,1.14,3.89s-.38,3-1.14,3.92c-.74.91-1.8,1.36-3.18,1.36s-2.46-.45-3.21-1.36c-.76-.92-1.14-2.23-1.14-3.92s.38-2.98,1.14-3.89c.75-.92,1.83-1.39,3.21-1.39Zm0,1.93c-.59,0-1.04.28-1.36.85-.31.55-.45,1.39-.45,2.5s.15,1.93.45,2.5c.32.57.77.85,1.36.85s1.03-.28,1.34-.85c.3-.57.45-1.4.45-2.5s-.16-1.95-.45-2.5c-.31-.57-.75-.85-1.34-.85Zm13.05,6.68c1.38,0,2.44.47,3.18,1.39.75.91,1.14,2.21,1.14,3.89s-.38,3-1.14,3.92c-.74.91-1.8,1.36-3.18,1.36s-2.46-.45-3.21-1.36c-.76-.92-1.14-2.23-1.14-3.92s.38-2.98,1.14-3.89c.75-.92,1.83-1.39,3.21-1.39Zm0,1.93c-.59,0-1.04.28-1.36.85-.31.57-.45,1.41-.45,2.5s.15,1.96.45,2.53c.32.55.77.82,1.36.82s1.03-.27,1.34-.82c.32-.57.48-1.41.48-2.53s-.16-1.93-.48-2.5c-.31-.57-.75-.85-1.34-.85Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.19,79.97c-.68,0-1.19.18-1.51.54-.33.36-.48.94-.48,1.73v1.11h2.67v2.39h-2.67v11.48h-3.1v-11.48h-2.33v-2.39h2.33v-1.48c0-1.4.35-2.46,1.05-3.18.72-.72,1.77-1.08,3.15-1.08.45,0,1,.06,1.65.17v2.3c-.27-.07-.53-.11-.77-.11Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.14,83.18c.36,0,.74.04,1.14.11v2.76c-.34-.06-.7-.09-1.08-.09-1.24,0-2.18.39-2.84,1.17-.67.76-.99,1.86-.99,3.3v6.79h-3.13v-13.87h2.9v2.05h.06c.92-1.48,2.25-2.22,3.95-2.22Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.4,82.95c1.38,0,2.59.31,3.61.91,1.04.59,1.83,1.44,2.39,2.53.55,1.1.82,2.4.82,3.89s-.28,2.8-.82,3.89c-.55,1.1-1.35,1.95-2.39,2.56-1.02.58-2.23.88-3.61.88s-2.6-.3-3.64-.88c-1.02-.6-1.82-1.46-2.39-2.56-.55-1.09-.82-2.39-.82-3.89s.27-2.79.82-3.89c.57-1.09,1.36-1.94,2.39-2.53,1.04-.6,2.25-.91,3.64-.91Zm0,2.44c-1.1,0-1.98.44-2.61,1.31-.63.87-.94,2.07-.94,3.58s.31,2.71.94,3.58c.64.87,1.51,1.31,2.61,1.31s1.99-.43,2.61-1.31c.64-.87.97-2.06.97-3.58s-.33-2.71-.97-3.58c-.63-.87-1.5-1.31-2.61-1.31Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.67,83.04c1.49,0,2.66.48,3.5,1.45.85.97,1.28,2.37,1.28,4.21v8.53h-3.13v-8.24c0-2.29-.84-3.44-2.5-3.44-.91,0-1.63.37-2.16,1.11-.51.74-.77,1.78-.77,3.1v7.48h-3.1v-8.56c0-.98-.22-1.75-.65-2.3-.44-.55-1.05-.82-1.85-.82-.93,0-1.65.38-2.16,1.14-.5.74-.74,1.78-.74,3.13v7.42h-3.13v-13.87h2.98v1.68h.06c.49-.68,1.05-1.18,1.68-1.51.63-.32,1.34-.48,2.16-.48.97,0,1.8.22,2.5.65.72.42,1.25,1.04,1.59,1.85.53-.81,1.14-1.43,1.85-1.85.72-.43,1.58-.65,2.59-.65Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.12,94.83c.4,0,.72-.04.97-.11v2.42c-.57.17-1.16.26-1.76.26-1.48,0-2.55-.33-3.21-.99-.67-.66-.99-1.75-.99-3.27v-7.39h-2.3v-2.39h2.3v-3.47h3.13v3.47h2.7v2.39h-2.7v6.94c0,.78.14,1.34.43,1.68.28.33.77.48,1.45.48Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406.68,82.95c1.38,0,2.59.31,3.61.91,1.04.59,1.83,1.44,2.39,2.53.55,1.1.82,2.4.82,3.89s-.28,2.8-.82,3.89c-.55,1.1-1.35,1.95-2.39,2.56-1.02.58-2.23.88-3.61.88s-2.6-.3-3.64-.88c-1.02-.6-1.82-1.46-2.39-2.56-.55-1.09-.82-2.39-.82-3.89s.27-2.79.82-3.89c.57-1.09,1.36-1.94,2.39-2.53,1.04-.6,2.25-.91,3.64-.91Zm0,2.44c-1.1,0-1.98.44-2.61,1.31-.63.87-.94,2.07-.94,3.58s.31,2.71.94,3.58c.64.87,1.51,1.31,2.61,1.31s1.99-.43,2.61-1.31c.64-.87.97-2.06.97-3.58s-.33-2.71-.97-3.58c-.63-.87-1.5-1.31-2.61-1.31Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.11,94.83c.4,0,.72-.04.97-.11v2.42c-.57.17-1.16.26-1.76.26-1.48,0-2.55-.33-3.21-.99-.67-.66-.99-1.75-.99-3.27v-7.39h-2.3v-2.39h2.3v-3.47h3.13v3.47h2.7v2.39h-2.7v6.94c0,.78.14,1.34.43,1.68.28.33.77.48,1.45.48Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.96,82.95c1.85,0,3.27.45,4.23,1.36.98.91,1.48,2.27,1.48,4.06v5.17c0,1.5.12,2.72.37,3.67h-2.81c-.14-.57-.2-1.21-.2-1.93h-.06c-1.02,1.5-2.58,2.25-4.66,2.25-1.42,0-2.56-.38-3.41-1.17-.85-.77-1.28-1.76-1.28-2.96s.4-2.14,1.19-2.84c.81-.72,2.19-1.23,4.12-1.53,1.15-.21,2.4-.34,3.75-.4v-.57c0-.97-.25-1.68-.74-2.13-.48-.47-1.14-.71-1.99-.71s-1.49.22-1.96.65c-.48.44-.73,1.02-.77,1.76h-3.04c.07-1.38.6-2.51,1.59-3.38.98-.87,2.37-1.31,4.18-1.31Zm2.73,7.7c-1.19.06-2.27.17-3.21.34-1.01.17-1.72.42-2.13.74-.4.33-.6.81-.6,1.45s.21,1.13.63,1.51c.43.36,1.05.54,1.85.54.49,0,.95-.07,1.39-.23.43-.15.8-.38,1.11-.71.36-.38.6-.77.74-1.19.15-.43.23-1.02.23-1.76v-.68Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.5,97.22v-19.44h3.13v19.44h-3.13Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.67,82.95c1.15,0,2.19.24,3.1.71.91.45,1.63,1.09,2.19,1.9.55.82.86,1.76.94,2.81h-3.24c-.08-.91-.39-1.63-.94-2.16-.53-.55-1.22-.82-2.05-.82-1.1,0-1.95.44-2.56,1.31-.61.87-.91,2.07-.91,3.58s.3,2.74.91,3.61c.6.85,1.46,1.28,2.56,1.28.83,0,1.51-.29,2.05-.88.53-.6.83-1.38.91-2.33h3.27c-.14,1.69-.77,3.06-1.9,4.09-1.12,1.04-2.56,1.56-4.32,1.56-1.35,0-2.53-.3-3.55-.88-1.02-.6-1.82-1.46-2.39-2.56-.55-1.09-.82-2.39-.82-3.89s.27-2.79.82-3.89c.57-1.09,1.36-1.94,2.39-2.53,1.02-.6,2.2-.91,3.55-.91Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m468.82,97.22v-19.44h3.13v19.44h-3.13Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m481.09,82.95c1.85,0,3.27.45,4.23,1.36.98.91,1.48,2.27,1.48,4.06v5.17c0,1.5.12,2.72.37,3.67h-2.81c-.14-.57-.2-1.21-.2-1.93h-.06c-1.02,1.5-2.58,2.25-4.66,2.25-1.42,0-2.56-.38-3.41-1.17-.85-.77-1.28-1.76-1.28-2.96s.4-2.14,1.19-2.84c.81-.72,2.19-1.23,4.12-1.53,1.15-.21,2.4-.34,3.75-.4v-.57c0-.97-.25-1.68-.74-2.13-.48-.47-1.14-.71-1.99-.71s-1.49.22-1.96.65c-.48.44-.73,1.02-.77,1.76h-3.04c.07-1.38.6-2.51,1.59-3.38.98-.87,2.37-1.31,4.18-1.31Zm2.73,7.7c-1.19.06-2.27.17-3.21.34-1.01.17-1.72.42-2.13.74-.4.33-.6.81-.6,1.45s.21,1.13.63,1.51c.43.36,1.05.54,1.85.54.49,0,.95-.07,1.39-.23.43-.15.8-.38,1.11-.71.36-.38.6-.77.74-1.19.15-.43.23-1.02.23-1.76v-.68Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490.62,97.22v-13.87h3.13v13.87h-3.13Zm0-16.46v-2.98h3.1v2.98h-3.1Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m513.12,83.04c1.49,0,2.66.48,3.5,1.45.85.97,1.28,2.37,1.28,4.21v8.53h-3.13v-8.24c0-2.29-.84-3.44-2.5-3.44-.91,0-1.63.37-2.16,1.11-.51.74-.77,1.78-.77,3.1v7.48h-3.1v-8.56c0-.98-.22-1.75-.65-2.3-.44-.55-1.05-.82-1.85-.82-.93,0-1.65.38-2.16,1.14-.5.74-.74,1.78-.74,3.13v7.42h-3.13v-13.87h2.98v1.68h.06c.49-.68,1.05-1.18,1.68-1.51.63-.32,1.34-.48,2.16-.48.97,0,1.8.22,2.5.65.72.42,1.25,1.04,1.59,1.85.53-.81,1.14-1.43,1.85-1.85.72-.43,1.58-.65,2.59-.65Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.5,82.95c1.78,0,3.15.41,4.12,1.22.98.8,1.49,1.96,1.51,3.5h-3.01c0-.81-.23-1.42-.68-1.82-.45-.41-1.11-.63-1.96-.63-.72,0-1.29.14-1.71.43-.4.28-.6.68-.6,1.19,0,.38.1.68.31.91.23.23.54.42.94.57.4.14,1.03.31,1.9.51,1.19.33,2.12.62,2.79.88.66.25,1.23.68,1.71,1.28.49.59.74,1.39.74,2.42,0,1.27-.53,2.3-1.59,3.07-1.04.75-2.44,1.14-4.21,1.14-1.9,0-3.38-.41-4.43-1.25-1.04-.85-1.56-2.08-1.56-3.69h3.15c0,.85.24,1.51.74,1.96.51.45,1.23.68,2.16.68.77,0,1.38-.15,1.82-.45.45-.32.68-.75.68-1.28,0-.45-.13-.81-.37-1.08-.23-.26-.57-.47-1.02-.63-.44-.15-1.14-.34-2.1-.57-1.08-.28-1.93-.54-2.53-.77-.61-.24-1.13-.63-1.56-1.17-.44-.55-.65-1.31-.65-2.27,0-.81.23-1.53.68-2.16.45-.64,1.09-1.14,1.9-1.48.81-.34,1.76-.51,2.84-.51Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m549.11,83.01c1.15,0,2.17.31,3.04.91.87.59,1.54,1.44,2.02,2.53.47,1.1.71,2.38.71,3.84s-.24,2.74-.71,3.84c-.48,1.1-1.15,1.95-2.02,2.56-.85.58-1.87.88-3.04.88-.87,0-1.67-.19-2.39-.57-.7-.38-1.26-.9-1.68-1.56h-.03v6.85h-3.13v-18.93h3.04v1.93h.06c.4-.72.95-1.28,1.68-1.68.74-.4,1.55-.6,2.44-.6Zm-.91,2.42c-1.02,0-1.84.44-2.44,1.31-.61.85-.91,2.04-.91,3.55s.3,2.69.91,3.55c.6.87,1.42,1.31,2.44,1.31s1.89-.43,2.5-1.31c.63-.89.94-2.07.94-3.55s-.31-2.65-.94-3.52c-.61-.89-1.44-1.34-2.5-1.34Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m563.68,95.34c.87,0,1.58-.21,2.13-.63.55-.41.9-.97,1.05-1.68h3.18c-.27,1.31-.97,2.4-2.1,3.27-1.12.87-2.54,1.31-4.26,1.31-1.39,0-2.59-.31-3.61-.94-1.01-.63-1.78-1.49-2.33-2.61-.53-1.14-.8-2.45-.8-3.95,0-1.36.26-2.59.8-3.67.53-1.09,1.29-1.95,2.3-2.56,1.02-.63,2.22-.94,3.58-.94,1.55,0,2.88.43,3.98,1.28,1.09.84,1.85,1.98,2.25,3.44.24.82.37,1.9.37,3.24h-10.18c.06,1.5.41,2.61,1.08,3.35.66.72,1.51,1.08,2.56,1.08Zm-.06-10.09c-.97,0-1.76.31-2.39.94-.63.61-1.01,1.5-1.14,2.67h7.02c-.11-1.17-.48-2.06-1.11-2.67-.63-.63-1.42-.94-2.39-.94Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m580.15,83.18c.36,0,.74.04,1.14.11v2.76c-.34-.06-.7-.09-1.08-.09-1.24,0-2.18.39-2.84,1.17-.67.76-.99,1.86-.99,3.3v6.79h-3.13v-13.87h2.9v2.05h.06c.92-1.48,2.25-2.22,3.95-2.22Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m598.82,97.22v-1.9h-.06c-.4.7-.97,1.25-1.71,1.65s-1.55.6-2.42.6c-1.16,0-2.18-.3-3.07-.88-.87-.6-1.55-1.46-2.02-2.56-.48-1.09-.71-2.37-.71-3.84s.23-2.74.71-3.84c.47-1.09,1.14-1.94,2.02-2.53.87-.6,1.88-.91,3.04-.91.87,0,1.66.19,2.39.57.72.38,1.28.91,1.68,1.59h.06v-7.39h3.1v19.44h-3.01Zm-3.27-11.8c-1.07,0-1.9.45-2.53,1.34-.61.87-.91,2.05-.91,3.52s.3,2.66.91,3.55c.63.87,1.46,1.31,2.53,1.31,1,0,1.8-.43,2.42-1.31.63-.87.94-2.05.94-3.55s-.31-2.7-.94-3.55c-.61-.87-1.41-1.31-2.42-1.31Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m611.59,95.34c.87,0,1.58-.21,2.13-.63.55-.41.9-.97,1.05-1.68h3.18c-.27,1.31-.97,2.4-2.1,3.27-1.12.87-2.54,1.31-4.26,1.31-1.39,0-2.59-.31-3.61-.94-1.01-.63-1.78-1.49-2.33-2.61-.53-1.14-.8-2.45-.8-3.95,0-1.36.26-2.59.8-3.67.53-1.09,1.29-1.95,2.3-2.56,1.02-.63,2.22-.94,3.58-.94,1.55,0,2.88.43,3.98,1.28,1.09.84,1.85,1.98,2.25,3.44.24.82.37,1.9.37,3.24h-10.18c.06,1.5.41,2.61,1.08,3.35.66.72,1.51,1.08,2.56,1.08Zm-.06-10.09c-.97,0-1.76.31-2.39.94-.63.61-1.01,1.5-1.14,2.67h7.02c-.11-1.17-.48-2.06-1.11-2.67-.63-.63-1.42-.94-2.39-.94Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.93,79.97c-.68,0-1.19.18-1.51.54-.33.36-.48.94-.48,1.73v1.11h2.67v2.39h-2.67v11.48h-3.1v-11.48h-2.33v-2.39h2.33v-1.48c0-1.4.35-2.46,1.05-3.18.72-.72,1.77-1.08,3.15-1.08.45,0,1,.06,1.65.17v2.3c-.27-.07-.53-.11-.77-.11Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m635.74,95.34c.87,0,1.58-.21,2.13-.63.55-.41.9-.97,1.05-1.68h3.18c-.27,1.31-.97,2.4-2.1,3.27-1.12.87-2.54,1.31-4.26,1.31-1.39,0-2.59-.31-3.61-.94-1.01-.63-1.78-1.49-2.33-2.61-.53-1.14-.8-2.45-.8-3.95,0-1.36.26-2.59.8-3.67.53-1.09,1.29-1.95,2.3-2.56,1.02-.63,2.22-.94,3.58-.94,1.55,0,2.88.43,3.98,1.28,1.09.84,1.85,1.98,2.25,3.44.24.82.37,1.9.37,3.24h-10.18c.06,1.5.41,2.61,1.08,3.35.66.72,1.51,1.08,2.56,1.08Zm-.06-10.09c-.97,0-1.76.31-2.39.94-.63.61-1.01,1.5-1.14,2.67h7.02c-.11-1.17-.48-2.06-1.11-2.67-.63-.63-1.42-.94-2.39-.94Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m652.47,83.04c1.59,0,2.82.48,3.69,1.45.89.97,1.34,2.38,1.34,4.23v8.5h-3.1v-8.21c0-2.31-.94-3.47-2.81-3.47-.93,0-1.69.36-2.27,1.05-.59.68-.88,1.66-.88,2.93v7.7h-3.13v-13.87h2.96v1.82h.06c.45-.66,1.03-1.18,1.73-1.56.72-.38,1.52-.57,2.42-.57Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m670.36,97.22v-1.9h-.06c-.4.7-.97,1.25-1.71,1.65s-1.55.6-2.42.6c-1.16,0-2.18-.3-3.07-.88-.87-.6-1.55-1.46-2.02-2.56-.48-1.09-.71-2.37-.71-3.84s.23-2.74.71-3.84c.47-1.09,1.14-1.94,2.02-2.53.87-.6,1.88-.91,3.04-.91.87,0,1.66.19,2.39.57.72.38,1.28.91,1.68,1.59h.06v-7.39h3.1v19.44h-3.01Zm-3.27-11.8c-1.07,0-1.9.45-2.53,1.34-.61.87-.91,2.05-.91,3.52s.3,2.66.91,3.55c.63.87,1.46,1.31,2.53,1.31,1,0,1.8-.43,2.42-1.31.63-.87.94-2.05.94-3.55s-.31-2.7-.94-3.55c-.61-.87-1.41-1.31-2.42-1.31Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m682.54,82.95c1.85,0,3.27.45,4.23,1.36.98.91,1.48,2.27,1.48,4.06v5.17c0,1.5.12,2.72.37,3.67h-2.81c-.14-.57-.2-1.21-.2-1.93h-.06c-1.02,1.5-2.58,2.25-4.66,2.25-1.42,0-2.56-.38-3.41-1.17-.85-.77-1.28-1.76-1.28-2.96s.4-2.14,1.19-2.84c.81-.72,2.19-1.23,4.12-1.53,1.15-.21,2.4-.34,3.75-.4v-.57c0-.97-.25-1.68-.74-2.13-.48-.47-1.14-.71-1.99-.71s-1.49.22-1.96.65c-.48.44-.73,1.02-.77,1.76h-3.04c.07-1.38.6-2.51,1.59-3.38.98-.87,2.37-1.31,4.18-1.31Zm2.73,7.7c-1.19.06-2.27.17-3.21.34-1.01.17-1.72.42-2.13.74-.4.33-.6.81-.6,1.45s.21,1.13.63,1.51c.43.36,1.05.54,1.85.54.49,0,.95-.07,1.39-.23.43-.15.8-.38,1.11-.71.36-.38.6-.77.74-1.19.15-.43.23-1.02.23-1.76v-.68Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m699.23,83.04c1.59,0,2.82.48,3.69,1.45.89.97,1.34,2.38,1.34,4.23v8.5h-3.1v-8.21c0-2.31-.94-3.47-2.81-3.47-.93,0-1.69.36-2.27,1.05-.59.68-.88,1.66-.88,2.93v7.7h-3.13v-13.87h2.96v1.82h.06c.45-.66,1.03-1.18,1.73-1.56.72-.38,1.52-.57,2.42-.57Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m713.69,94.83c.4,0,.72-.04.97-.11v2.42c-.57.17-1.16.26-1.76.26-1.48,0-2.55-.33-3.21-.99-.67-.66-.99-1.75-.99-3.27v-7.39h-2.3v-2.39h2.3v-3.47h3.13v3.47h2.7v2.39h-2.7v6.94c0,.78.14,1.34.43,1.68.28.33.77.48,1.45.48Z",
    style: {
      fill: "#999"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfographics2);
export default __webpack_public_path__ + "static/media/infographics-2.732610d1d8592942264680b6aa26ef5d.svg";
export { ForwardRef as ReactComponent };